'use strict';

// This file is bundled into a browser package and needs to remain as es5. This includes any
// required dependencies, each of those and their dependencies need to be es5. Also check that
// if you require a new module it doesn't expose anything publicly that should remain private.
//
// Any 3rd party dependencies that you require below, will need an equivalently named browser
// version that is mapped to the same name. Add the 3rd party dependency to the WebConfig
// object in 'ps-common/web/tasks/ps-server-to-client.js' so that webpack doesn't bundle it
// in with this code. It will need to be included in the lib package in the webapp.

const publicConstants = {};

// The following can be removed after refactoring and all callers have been updated

// end

publicConstants.ApprovalStatus = {
    InsufficientData: 0,
    ReadyForApproval: 1,
    PendingApproval: 2,
    Approved: 3,
    Rejected: 4,
};

publicConstants.BetaLevels = {
    all: 0,
    broadCustomer: 1,
    limitedCustomer: 2,
    broadPushSpring: 4,
    limitedPushSpring: 5,
    developers: 6,
};

publicConstants.DataScienceTeam = {
    1840: { name: 'Megan Jasek', email: 'megan@pushspring.com' },
    3304: { name: 'Stewart Renehan', email: 'stewart@pushspring.com' },
};

publicConstants.featureFlags = {
    // Changing this value requires restarting ps-workers, ps-jobscripts, and exploratron
    comScoreInConsole: true,
    // If you enable comscore gender it will hide PS gender, and will start calculating segment gender based off of PS gender instead of comscore gender.
    useComScoreGender: true,
};

publicConstants.Gender = {};
publicConstants.Gender.Unknown = 0;
publicConstants.Gender.Male = 1;
publicConstants.Gender.Female = 2;

publicConstants.UserOrgRoles = {};
publicConstants.UserOrgRoles.Member = 0;
publicConstants.UserOrgRoles.Admin = 1;

// Bit mask fields powers of 2
publicConstants.OrgType = {
    Agency: 1,
    Publisher: 2,
};

// Developer not list to prevent inclusion in ui lists
publicConstants.UserOrgRoleList = [
    { _id: publicConstants.UserOrgRoles.Member, name: 'Member' },
    { _id: publicConstants.UserOrgRoles.Admin, name: 'Admin' },
];

publicConstants.OrgRoles = {};
publicConstants.OrgRoles.Angletron = 1;
publicConstants.OrgRoles.Exploratron = 2;
publicConstants.OrgRoles.ExploratronAudienceInsightsTier1 = 3;
publicConstants.OrgRoles.Developer = 4;
publicConstants.OrgRoles.Partnertron = 5;
publicConstants.OrgRoles.RevenueReporting = 6;
publicConstants.OrgRoles.ExploratronAudienceInsightsTier2 = 7;
publicConstants.OrgRoles.CustomCPM = 8;
publicConstants.OrgRoles.Publishertron = 9;
publicConstants.OrgRoles.ExploratronAppInsightsTier1 = 10;
publicConstants.OrgRoles.ExploratronAppInsightsTier2 = 11;
publicConstants.OrgRoles.ExploratronAppMeasurementTier1 = 12;
publicConstants.OrgRoles.ExploratronAppMeasurementTier2 = 13;

publicConstants.StaffRoles = {
    AccountManager: 1,
    SalesOwner: 2,
};

publicConstants.PartnerImport = { Status: { Pending: 0, Importing: 1, Done: 2, Error: 3 } };

publicConstants.SearchMetadata = { Status: {} };
publicConstants.SearchMetadata.Status.Normal = 0;
publicConstants.SearchMetadata.Status.Deleted = 1;

publicConstants.SegmentReports = {};
publicConstants.SegmentReports.Types = {};
publicConstants.SegmentReports.Types.SegmentCompositionReport = 1;
publicConstants.SegmentReports.Types.SegmentCompositionComparisonReport = 2;
publicConstants.SegmentReports.Types.AudienceResearchReport = 3;
publicConstants.SegmentReports.Types.AppResearchReport = 4;
publicConstants.SegmentReports.Types.AppUsageLeaderboardReport = 5;
publicConstants.SegmentReports.Types.AudienceInsightsSummaryReport = 6;

publicConstants.SegmentReports.Formats = {};
publicConstants.SegmentReports.Formats.Pdf = 'pdf';
publicConstants.SegmentReports.Formats.PowerPoint = 'ppt';
publicConstants.SegmentReports.Formats.Csv = 'csv';

publicConstants.UploadAudience = { Status: {} };
publicConstants.UploadAudience.Status.Pending = 0;
publicConstants.UploadAudience.Status.Running = 1;
publicConstants.UploadAudience.Status.Finished = 2;
publicConstants.UploadAudience.Status.Error = 3;
publicConstants.UploadAudience.Status.Deleted = 4;
publicConstants.UploadAudience.Status.ValidationFailed = 5;
publicConstants.UploadAudience.Status.Clear = 6;

publicConstants.CustomAudienceType = { Uploaded: 1, Api: 2, UploadedV2: 3 };

publicConstants.TargetListExport = { Status: {}, Type: {}, OutputFormat: {} };
publicConstants.TargetListExport.Type.AppList = 0;
publicConstants.TargetListExport.Type.Persona = 1;
publicConstants.TargetListExport.Type.WarehouseCustomSegment = 2;
publicConstants.TargetListExport.OutputFormat.PushSpringCSV = 0;
publicConstants.TargetListExport.OutputFormat.FacebookMADID = 1;

publicConstants.TargetListExport.Status.Pending = 0;
publicConstants.TargetListExport.Status.Uploading = 1;
publicConstants.TargetListExport.Status.Exporting = 2;
publicConstants.TargetListExport.Status.Finished = 3;

publicConstants.FilePickerAPIKey = 'ATQCtYrTmQVCKugAHZGzAz';
publicConstants.FilePickerBucket = 'filepicker.pushspring.com'; //Not env specific, so put here instead of libs/core/server/src/lib/runtimeSettings.ts

publicConstants.BuiltInSegmentsMaxId = 100000; // all built in segments below (including persona segments) need id's below this value

publicConstants.BuiltInSegments = {
    allUsers: { _id: 0, name: 'All Devices' },
    inactiveUsers: { _id: 1, name: 'Inactive Devices', hideInExploratron: true },
    newUsersLast30: { _id: 2, name: 'New Devices Last 30 Days', hideInExploratron: true },
    iOSUsers: { _id: 3, name: 'iOS Devices', hideInExploratron: true },
    androidUsers: { _id: 4, name: 'Android Devices', hideInExploratron: true },
};

publicConstants.WarehouseSegments = { Type: {}, Status: {}, CalcRequired: {} };
publicConstants.WarehouseSegments.Type.CustomSegments = 0;
// Imported
publicConstants.WarehouseSegments.Type.MatchedAudience = 1;
// Deprecated
publicConstants.WarehouseSegments.Type.AppAudience = 2;
// Apps
publicConstants.WarehouseSegments.Type.SdkAudience = 3;

publicConstants.WarehouseSegments.Type.LookalikeSegment = 4;
// Pixels or direct API
publicConstants.WarehouseSegments.Type.ApiAudience = 5;

publicConstants.WarehouseSegments.Status.Normal = 0;
publicConstants.WarehouseSegments.Status.Archived = 1;
publicConstants.WarehouseSegments.Status.Error = 2;
publicConstants.WarehouseSegments.Status.Calculating = 3;

publicConstants.WarehouseSegments.CalcRequired.NewEdit = 1;
publicConstants.WarehouseSegments.CalcRequired.Nightly = 2;

//Roughly 50% of adult population
publicConstants.maximumLookalikeSizeByCountry = {
    US: 115000000,
    AU: 12500000,
    CA: 15000000,
};

publicConstants.PartnerTransmitSegmentSchedules = {
    Type: {
        Devices: 0,
        Cookies: 1,
        CookiesAndDevices: 2,
    },
};

publicConstants.PartnerTransmitSegmentLogs = {
    Status: {
        Pending: { _id: 0, name: 'Pending' },
        Querying: { _id: 1, name: 'Querying' },
        Processing: { _id: 2, name: 'Processing' },
        Uploading: { _id: 3, name: 'Uploading' },
        Finished: { _id: 4, name: 'Finished' },
        Error: { _id: 5, name: 'Error' },
        Duplicate: { _id: 6, name: 'Duplicate' },
        Canceled: { _id: 7, name: 'Canceled' },
    },
};

publicConstants.Marketplace = {
    PartnerReports: {
        Type: [
            { id: 0, name: 'Billing Statement' },
            //          { id: 1, name: "Final Statement" },
            { id: 2, name: 'Custom Audiences' },
            { id: 3, name: 'Attributes' },
            { id: 4, name: 'Courtesy' },
        ],
    },
};

// This list defines the partners we ingest data from or
// transmit segments to. It drives the partner transmit logs
// and schedules.
publicConstants.Partners = {};
publicConstants.Partners.DoubleClick = 1; // Deprecated partner
publicConstants.Partners.AppNexus = 2; // Deprecated partner
publicConstants.Partners.Centro = 3;
publicConstants.Partners.TradeDesk = 4;
publicConstants.Partners.Turn = 5;
publicConstants.Partners.Twitter = 6;
publicConstants.Partners.Acxiom = 7; // LiveRamp
publicConstants.Partners.Oracle = 8; // Deprecated partner
publicConstants.Partners.AdTheorent = 9;
publicConstants.Partners.MediaMath = 10; // Deprecated partner
publicConstants.Partners.Manual = 11; // Used to capture manual process, e.g. upload to S3 and email to partner
publicConstants.Partners.Digilant = 12;
publicConstants.Partners.Netmining = 13;
publicConstants.Partners.TubeMogul = 14;
publicConstants.Partners.Adelphic = 15; // Deprecated partner
publicConstants.Partners.Facebook = 16;
publicConstants.Partners.Adobe = 17;
publicConstants.Partners.NativeTouch = 18;
publicConstants.Partners.Drawbridge = 19;
publicConstants.Partners.Snap = 20;
publicConstants.Partners.Blis = 21;
publicConstants.Partners.SMS = 22;
publicConstants.Partners.Bombora = 23;
publicConstants.Partners.AmeribaseDigital = 24;
publicConstants.Partners.Stirista = 25;
publicConstants.Partners.V12 = 26;
publicConstants.Partners.PlaceIQ = 27;
publicConstants.Partners.Valassis = 28;
publicConstants.Partners.Vistar = 29;
publicConstants.Partners.Smadex = 30;
publicConstants.Partners.Run = 31;
publicConstants.Partners.Neustar = 32;
publicConstants.Partners.Ubimo = 33;
publicConstants.Partners.Tivo = 34;
publicConstants.Partners.IRI = 35;
publicConstants.Partners.OneEightyByTwo = 36;
publicConstants.Partners.Clickagy = 37;
publicConstants.Partners.Nielsen = 38;
publicConstants.Partners.Alliant = 39;
publicConstants.Partners.Reveal = 40;
publicConstants.Partners.Epsilon = 41;
publicConstants.Partners.PlatformIO = 42;
publicConstants.Partners.ASLMarketing = 43;
publicConstants.Partners.ShareThis = 44;
publicConstants.Partners.NinthDecimal = 45;
publicConstants.Partners.AnalyticsIQ = 46;
publicConstants.Partners.Locally = 47;
publicConstants.Partners.AffinityAnswers = 48;
publicConstants.Partners.AffinitySolutions = 49;
publicConstants.Partners.MeritDirect = 50;
publicConstants.Partners.StatSocial = 51;
publicConstants.Partners.Skyhook = 52;
publicConstants.Partners.Audigent = 53;
publicConstants.Partners.CrossPixel = 54;
publicConstants.Partners.PeerLogix = 55;
publicConstants.Partners.Webbula = 56;
publicConstants.Partners.Claritas = 57;
publicConstants.Partners.ThirtyThreeAcross = 58;
publicConstants.Partners.DishTV = 59;
publicConstants.Partners.Insticator = 60;
publicConstants.Partners.AmazonAdvertising = 61;
publicConstants.Partners.ALC = 62;
publicConstants.Partners.Xmode = 63;
publicConstants.Partners.Bridge = 64;
publicConstants.Partners.Dstillery = 65;
publicConstants.Partners.Wiland = 66;
publicConstants.Partners.Equifax = 67;
publicConstants.Partners.Killi = 68;
publicConstants.Partners.DataAxle = 69;
publicConstants.Partners.JunGroup = 70;
publicConstants.Partners.SimpliFi = 71;
publicConstants.Partners.TremorVideo = 72;
publicConstants.Partners.Alphonso = 73;
publicConstants.Partners.Fyllo = 74;
publicConstants.Partners.Catalina = 75;
publicConstants.Partners.StackAdapt = 76;
publicConstants.Partners.Kargo = 77;
publicConstants.Partners.Foursquare = 78;
publicConstants.Partners.DigitalTurbine = 79;
publicConstants.Partners.InMarket = 80;
publicConstants.Partners.AmeriLink = 81;
publicConstants.Partners.TivoBDEX = 82;
publicConstants.Partners.MagentaMarketingPlatform = 83; //TODO: look into accessor, seems to be done improperly
publicConstants.Partners.PlaceIQDirect = 84;
publicConstants.Partners.StartIO = 85;
publicConstants.Partners.Martin = 86;
publicConstants.Partners.IHSMarkitPolk = 87;
publicConstants.Partners.Comscore = 88;
publicConstants.Partners.CIS = 89;
publicConstants.Partners.Homedata = 90;
publicConstants.Partners.SambaTV = 91;
publicConstants.Partners.Loopme = 92;
publicConstants.Partners.AnalyticsIQDirect = 1741;
publicConstants.Partners.DeepSync = 93;
publicConstants.Partners.AudienceApiSliide = 94;
publicConstants.Partners.AudienceApiUnity = 95;

publicConstants.PartnerRollups = [publicConstants.Partners.Acxiom, publicConstants.Partners.TradeDesk];

publicConstants.LightweightPartners = {};
publicConstants.LightweightPartners[publicConstants.Partners.Vistar] = {
    isAssumedRole: true,
    region: 'us-east-1',
    arn: 'arn:aws:iam::041138300700:role/svc_tdl_vistar_prd',
    arnSessionName: 'vistar-transmit-segment',
    s3Bucket: 'vistar-t-ads-drop',
    s3path: 'custom_3P_audience_segments/',
    singleFile: true,
    isCustomPath: true,
    fileExtension: '.gz',
};
publicConstants.LightweightPartners[publicConstants.Partners.Neustar] = {
    isAssumedRole: false,
    s3path: 'neustar/custom/',
};
publicConstants.LightweightPartners[publicConstants.Partners.Manual] = {
    isAssumedRole: false,
    s3path: 'pushspring/manual/',
};
publicConstants.LightweightPartners[publicConstants.Partners.Ubimo] = {
    isAssumedRole: false,
    s3path: 'Ubimo/custom/',
};
publicConstants.LightweightPartners[publicConstants.Partners.PlatformIO] = {
    isAssumedRole: false,
    s3path: 'platformio/custom/',
};
publicConstants.LightweightPartners[publicConstants.Partners.NinthDecimal] = {
    isAssumedRole: false,
    s3path: 'ninthdecimal/custom/',
};
publicConstants.LightweightPartners[publicConstants.Partners.DigitalTurbine] = {
    isAssumedRole: false,
    s3Bucket: 'tpbid-audience-dt-global',
    s3path: '',
    awsSecret: 'digitalturbine-s3-access-credentials',
};
publicConstants.LightweightPartners[publicConstants.Partners.AudienceApiSliide] = {
    isAssumedRole: false,
    s3path: 'audience-api/sliide/custom/',
};
publicConstants.LightweightPartners[publicConstants.Partners.AudienceApiUnity] = {
    isAssumedRole: false,
    s3path: 'audience-api/unity/custom/',
};

publicConstants.LightweightPartnerList = Object.keys(publicConstants.LightweightPartners).map((partnerId) => {
    return parseInt(partnerId);
});

// Deprecated partners must stay for reporting purposes
publicConstants.PartnerList = [
    { name: 'Acxiom', value: publicConstants.Partners.Acxiom + '', needsSegmentId: false },
    { name: 'Adelphic', value: publicConstants.Partners.Adelphic + '', needsSegmentId: false },
    { name: 'AdTheorent', value: publicConstants.Partners.AdTheorent + '', needsSegmentId: false },
    { name: 'AppNexus', value: publicConstants.Partners.AppNexus + '', needsSegmentId: true },
    { name: 'Centro', value: publicConstants.Partners.Centro + '', needsSegmentId: false },
    { name: 'DoubleClick', value: publicConstants.Partners.DoubleClick + '', needsSegmentId: true },
    { name: 'Facebook', value: publicConstants.Partners.Facebook + '', needsSegmentId: false },
    { name: 'MediaMath', value: publicConstants.Partners.MediaMath + '', needsSegmentId: false },
    { name: 'Oracle', value: publicConstants.Partners.Oracle + '', needsSegmentId: false },
    { name: 'The Trade Desk', value: publicConstants.Partners.TradeDesk + '', needsSegmentId: false },
    { name: 'Turn', value: publicConstants.Partners.Turn + '', needsSegmentId: false },
    { name: 'Manual', value: publicConstants.Partners.Manual + '', needsSegmentId: false },
    { name: 'Digilant', value: publicConstants.Partners.Digilant + '', needsSegmentId: false },
    { name: 'NetMining', value: publicConstants.Partners.Netmining + '', needsSegmentId: false },
    { name: 'RUN', value: publicConstants.Partners.Run + '', needsSegmentId: false },
    { name: 'Adobe', value: publicConstants.Partners.Adobe + '', needsSegmentId: false },
    { name: 'Native Touch', value: publicConstants.Partners.NativeTouch + '', needsSegmentId: false },
    { name: 'Drawbridge', value: publicConstants.Partners.Drawbridge + '', needsSegmentId: false },
    { name: 'Snap', value: publicConstants.Partners.Snap + '', needsSegmentId: false },
    { name: 'Blis', value: publicConstants.Partners.Blis + '', needsSegmentId: false },
    { name: 'Valassis', value: publicConstants.Partners.Valassis + '', needsSegmentId: false },
    { name: 'Vistar', value: publicConstants.Partners.Vistar + '', needsSegmentId: false },
    { name: 'Smadex', value: publicConstants.Partners.Smadex + '', needsSegmentId: false },
    { name: 'Neustar', value: publicConstants.Partners.Neustar + '', needsSegmentId: false },
    { name: 'Ubimo', value: publicConstants.Partners.Ubimo + '', needsSegmentId: false },
    { name: 'Nielsen', value: publicConstants.Partners.Nielsen + '', needsSegmentId: false },
    { name: 'PlatformIO', value: publicConstants.Partners.PlatformIO + '', needsSegmentId: false },
    { name: 'NinthDecimal', value: publicConstants.Partners.NinthDecimal + '', needsSegmentId: false },
    { name: 'DigitalTurbine', value: publicConstants.Partners.DigitalTurbine + '', needsSegmentId: false },
    { name: 'StartIO', value: publicConstants.Partners.StartIO + '', needsSegmentId: false },
    { name: 'Martin', value: publicConstants.Partners.Martin + '', needsSegmentId: false },
    { name: 'AudienceApiSliide', value: publicConstants.Partners.AudienceApiSliide + '', needsSegmentId: false },
    { name: 'AudienceApiUnity', value: publicConstants.Partners.AudienceApiUnity + '', needsSegmentId: false },
];

// This list defines integrations that appear in the send to partner UI
publicConstants.ExternalIntegrations = { Type: {} };
publicConstants.ExternalIntegrations.Type.TradeDesk = 1;
publicConstants.ExternalIntegrations.Type.DoubleClick = 2;
publicConstants.ExternalIntegrations.Type.InMobi = 3;
publicConstants.ExternalIntegrations.Type.Adelphic = 4;
publicConstants.ExternalIntegrations.Type.AolOne = 5;
publicConstants.ExternalIntegrations.Type.Nanigans = 6;
publicConstants.ExternalIntegrations.Type.Manage = 7;
publicConstants.ExternalIntegrations.Type.PocketMath = 8;
publicConstants.ExternalIntegrations.Type.AppNexus = 9;
publicConstants.ExternalIntegrations.Type.CentroSiteScout = 10;
publicConstants.ExternalIntegrations.Type.StrikeAd = 11;
publicConstants.ExternalIntegrations.Type.OracleBlueKai = 12;
publicConstants.ExternalIntegrations.Type.Twitter = 13;
publicConstants.ExternalIntegrations.Type.Facebook = 14;
publicConstants.ExternalIntegrations.Type.RocketFuel = 15;
publicConstants.ExternalIntegrations.Type.LiveRamp = 16;
publicConstants.ExternalIntegrations.Type.DataXu = 17;
publicConstants.ExternalIntegrations.Type.MediaMath = 18;
publicConstants.ExternalIntegrations.Type.AdTheorent = 19;
publicConstants.ExternalIntegrations.Type.VerveMobile = 20;
publicConstants.ExternalIntegrations.Type.Digilant = 21;
publicConstants.ExternalIntegrations.Type.Netmining = 22;
publicConstants.ExternalIntegrations.Type.TubeMogul = 23;
publicConstants.ExternalIntegrations.Type.Krux = 24;
publicConstants.ExternalIntegrations.Type.Run = 25;
publicConstants.ExternalIntegrations.Type.Adobe = 26;
publicConstants.ExternalIntegrations.Type.Tapad = 27;
publicConstants.ExternalIntegrations.Type.Yahoo = 28;
publicConstants.ExternalIntegrations.Type.VideoAmp = 29;
// This is on purpose to prevent the old inmobi external ExternalIntegrations
// from being used.  We are treating as new partner
publicConstants.ExternalIntegrations.Type.InMobiLiveRamp = 30;
publicConstants.ExternalIntegrations.Type.RocketFuelLiveRamp = 31;
publicConstants.ExternalIntegrations.Type.NativeTouch = 32;
publicConstants.ExternalIntegrations.Type.Drawbridge = 33;
publicConstants.ExternalIntegrations.Type.AppNexusLiveRamp = 34;
publicConstants.ExternalIntegrations.Type.Aki = 35;
publicConstants.ExternalIntegrations.Type.Snap = 36;
publicConstants.ExternalIntegrations.Type.Turn = 37;
publicConstants.ExternalIntegrations.Type.Blis = 38;
publicConstants.ExternalIntegrations.Type.RhythmOne = 39;
publicConstants.ExternalIntegrations.Type.Videology = 40;
publicConstants.ExternalIntegrations.Type.Adform = 41;
publicConstants.ExternalIntegrations.Type.LoopMe = 42;
publicConstants.ExternalIntegrations.Type.ThinkNear = 43;
publicConstants.ExternalIntegrations.Type.Jampp = 44;
publicConstants.ExternalIntegrations.Type.Beeswax = 45;
publicConstants.ExternalIntegrations.Type.LiveIntent = 46;
publicConstants.ExternalIntegrations.Type.Avocet = 47;
publicConstants.ExternalIntegrations.Type.PlaceIQ = 48;
publicConstants.ExternalIntegrations.Type.OwnerIQ = 49;
publicConstants.ExternalIntegrations.Type.Valassis = 50;
publicConstants.ExternalIntegrations.Type.Vistar = 51;
publicConstants.ExternalIntegrations.Type.Smadex = 52;
publicConstants.ExternalIntegrations.Type.PushSpringManual = 53;
publicConstants.ExternalIntegrations.Type.Neustar = 54;
publicConstants.ExternalIntegrations.Type.Ubimo = 55;
publicConstants.ExternalIntegrations.Type.Nielsen = 56;
publicConstants.ExternalIntegrations.Type.Teads = 57;
publicConstants.ExternalIntegrations.Type.PlatformIO = 58;
publicConstants.ExternalIntegrations.Type.Dstillery = 59;
publicConstants.ExternalIntegrations.Type.Hulu = 60;
publicConstants.ExternalIntegrations.Type.Tremor = 61;
publicConstants.ExternalIntegrations.Type.AdTheorentLR = 62;
publicConstants.ExternalIntegrations.Type.Scope = 63;
publicConstants.ExternalIntegrations.Type.Pinterest = 64;
publicConstants.ExternalIntegrations.Type.AmazonAdvertising = 65;
publicConstants.ExternalIntegrations.Type.FacebookLiveRamp = 66;
publicConstants.ExternalIntegrations.Type.NinthDecimal = 67;
publicConstants.ExternalIntegrations.Type.TMobileAudienceNetwork = 68; // Now called Magenta Audience Network
publicConstants.ExternalIntegrations.Type.Spotify = 69;
publicConstants.ExternalIntegrations.Type.JunGroup = 70;
publicConstants.ExternalIntegrations.Type.SimpliFi = 71;
publicConstants.ExternalIntegrations.Type.TremorVideo = 72;
publicConstants.ExternalIntegrations.Type.Alphonso = 73;
publicConstants.ExternalIntegrations.Type.StackAdapt = 74;
publicConstants.ExternalIntegrations.Type.Kargo = 75;
publicConstants.ExternalIntegrations.Type.DigitalTurbine = 76;
publicConstants.ExternalIntegrations.Type.FacebookLiveRampV2 = 77;
publicConstants.ExternalIntegrations.Type.SnapLiveRamp = 78;
publicConstants.ExternalIntegrations.Type.StartIO = 79;
publicConstants.ExternalIntegrations.Type.Martin = 80;
publicConstants.ExternalIntegrations.Type.Dooh = 81;
publicConstants.ExternalIntegrations.Type.BlisLiveRamp = 82;
publicConstants.ExternalIntegrations.Type.BlisDirect = 83;
publicConstants.ExternalIntegrations.Type.AudienceApiSliide = 84;
publicConstants.ExternalIntegrations.Type.AudienceApiUnity = 85;

publicConstants.ExternalIntegrations.ValidationStatus = {
    Unknown: 0,
    Valid: 1,
    Invalid: 2,
};

publicConstants.standardSLA = { message: '5-7 business days', days: 7 };
publicConstants.SLAOneDay = { message: '1 business day', days: 1 };
publicConstants.SLATwoToThreeDays = { message: '2-3 business days', days: 3 };
publicConstants.SLAThreeToFiveDays = { message: '3-5 business days', days: 5 };

publicConstants.IntegrationCategories = {
    DSP: { id: 1, title: 'Demand Side Platforms' },
    Social: { id: 2, title: 'Social' },
    DMP: { id: 3, title: 'Data Management Platforms' },
};

// Never remove constants from here.  It will cause old exports to fail to lookup the integration and
// show the right icon, etc
publicConstants.ExternalIntegrationsTemplate = [
    {
        type: publicConstants.ExternalIntegrations.Type.Tapad,
        platformName: 'Tapad',
        platformKey: 'tapad',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Tapad Advertiser Id',
                key: 'tapadAdvertiserId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Yahoo,
        platformName: 'Yahoo',
        platformKey: 'yahoo',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        alternatePricingMessage: 'Data fees are included as a part of your media costs.',
        searchTerms: 'yahoo, brightroll, oath',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Agency Name',
                key: 'agencyName',
                value: '',
                optional: true,
            },
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                optional: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.VideoAmp,
        platformName: 'VideoAmp',
        platformKey: 'videoamp',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Account Id',
                key: 'videoAmpAccountId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.TradeDesk,
        platformName: 'The Trade Desk',
        platformKey: 'thetradedesk',
        partnerId: publicConstants.Partners.TradeDesk,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForInternalNewIntegrations: true,
        availableForExistingIntegrations: true,
        availableForExistingOrgIds: [285, 1506, 1324, 482, 69, 1723, 1766],
        searchTerms: 'ttd thetradedesk',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Partner ID',
                key: 'partnerId',
                value: '',
                primary: true,
            },
            {
                displayName: 'Partner Name',
                key: 'partnerName',
                value: '',
            },
            {
                displayName: 'TTD Account Manager',
                key: 'accountManager',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLATwoToThreeDays,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.DoubleClick,
        platformName: 'DV360',
        platformKey: 'doubleclick',
        partnerId: publicConstants.Partners.DoubleClick,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForInternalNewIntegrations: false,
        availableForExistingIntegrations: false,
        availableForExistingOrgIds: [285, 482, 654, 69, 1615, 1506, 1766, 1564],
        searchTerms: 'dbm dfp google dv360 doubleclick',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Product',
                key: 'product',
                value: '',
                options: [
                    {
                        display: 'Bid Manager Partner',
                        value: 'Bid_Manager_Partner',
                    },
                    {
                        display: 'Bid Manager Advertiser',
                        value: 'Bid_Manager_Advertiser',
                    },
                    {
                        display: 'DoubleClick for Publishers',
                        value: 'dfp',
                    },
                ],
            },
            {
                displayName: 'Customer ID',
                key: 'customerId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLAOneDay,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.InMobi,
        platformName: 'InMobi',
        platformKey: 'inmobi',
        partnerId: publicConstants.Partners.InMobi,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Client Name',
                key: 'clientName',
                value: '',
            },
            {
                displayName: 'Seat ID',
                key: 'seatId',
                value: '',
                primary: true,
            },
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                optional: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.InMobiLiveRamp,
        platformName: 'InMobi',
        platformKey: 'inmobi',
        partnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Client Name',
                key: 'clientName',
                value: '',
            },
            {
                displayName: 'Seat ID',
                key: 'seatId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Adelphic,
        platformName: 'Adelphic',
        platformKey: 'adelphic',
        partnerId: publicConstants.Partners.Adelphic,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        suppressCreateIntegration: true,
        searchTerms: 'adelphic viant time',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'API User',
                key: 'apiUser',
                value: '',
                primary: true,
            },
            {
                displayName: 'API Password',
                key: 'apiPassword',
                value: '',
            },
            {
                displayName: 'Advertiser Id',
                key: 'advertiserId',
                value: '',
                optional: true,
            },
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                optional: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLATwoToThreeDays,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.AolOne,
        platformName: 'Verizon Media',
        platformKey: 'aolone',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        alternatePricingMessage: 'Data fees are included as a part of your media costs.',
        note: 'After exporting you will need to provide the corresponding AOL LiveRamp ID(s) to your Verizon Media rep. The ID(s) will be sent to you by PushSpring within 1-2 business days.',
        searchTerms: 'aol oath',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Verizon Media Rep Email',
                key: 'aolRepEmail', //changed the display name from AOL to Verizon, leaving key the same.
                value: '',
                primary: true,
            },
            {
                displayName: 'Mdm ID',
                key: 'mdmId',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Run,
        platformName: 'RUN',
        platformKey: 'run',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'runAdvertiserName',
                value: '',
            },
            {
                displayName: 'Company or Account at RUN',
                key: 'runCompanyOrAccount',
                value: '',
                primary: true,
            },
            {
                displayName: 'RUN Rep Email',
                key: 'runRepEmail',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Nanigans,
        platformName: 'Nanigans',
        platformKey: 'nanigans',
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 'Seat Name',
                key: 'seatName',
                value: '',
            },
            {
                displayName: 'Seat ID',
                key: 'seatId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Manage,
        platformName: 'Manage',
        platformKey: 'manage',
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 'Seat Name',
                key: 'seatName',
                value: '',
            },
            {
                displayName: 'Seat ID',
                key: 'seatId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.PocketMath,
        platformName: 'PocketMath',
        platformKey: 'pocketmath',
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 'Seat Name',
                key: 'seatName',
                value: '',
            },
            {
                displayName: 'Seat ID',
                key: 'seatId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            0: publicConstants.standardSLA,
        },
    },
    // Leave in place otherwise breaks code that loads old integrations
    {
        type: publicConstants.ExternalIntegrations.Type.AppNexus,
        platformName: 'AppNexus Old',
        platformKey: 'appnexus',
        partnerId: publicConstants.Partners.AppNexus,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [],
        slas: {},
    },
    {
        type: publicConstants.ExternalIntegrations.Type.AppNexusLiveRamp,
        platformName: 'Xandr',
        platformKey: 'appnexus',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Xandr Seat ID',
                key: 'appNexusSeatId',
                value: '',
                primary: true,
            },
            {
                displayName: 'Agency Name',
                key: 'agencyName',
                value: '',
                optional: true,
            },
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                optional: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.CentroSiteScout,
        platformName: 'CentroSiteScout',
        platformKey: 'centrositescout',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: 'centro sitescout site scout basis',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                optional: true,
            },
            {
                displayName: 'Centro Advertiser ID',
                key: 'centroAdvertiserId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.StrikeAd,
        platformName: 'StrikeAd',
        platformKey: 'strikead',
        partnerId: publicConstants.Partners.Manual,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
                optional: true,
            },
        ],
        slas: {
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.OracleBlueKai,
        platformName: 'Oracle | BlueKai',
        platformKey: 'oraclebluekai',
        partnerId: publicConstants.Partners.Oracle,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 'Buyer Name',
                key: 'buyerName',
                value: '',
            },
            {
                displayName: 'Buyer ID',
                key: 'buyerId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Twitter,
        platformName: 'Twitter',
        platformKey: 'twitter',
        partnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: true,
        availableForExistingIntegrations: true,
        suppressCreateIntegration: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.Social.id,
        alternatePricingMessage: 'Pricing will be set by your agreement with LiveRamp',
        note: 'Activate on social media platforms via a LiveRamp Advertiser Direct contract. Please work with a LiveRamp rep to set this up if not already in place. Pricing and reporting standards will be set according to your agreement.',
        integrationInfo: [
            {
                displayName: 'LiveRamp Account Name',
                key: 'liverampAccountName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Facebook,
        platformName: 'Facebook - Direct',
        platformKey: 'facebook',
        availableForNewIntegrations: false,
        availableForInternalNewIntegrations: true,
        availableForExistingIntegrations: true,
        partnerId: publicConstants.Partners.Facebook,
        suppressCreateIntegration: true,
        searchTerms: 'instagram',
        category: publicConstants.IntegrationCategories.Social.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
            },
            {
                displayName: 'Facebook Ad Account ID',
                key: 'facebookAdvertiserId',
                value: '',
                primary: true,
            },
            {
                displayName: 'Agency Name',
                key: 'agencyName',
                value: '',
            },
            {
                displayName: '% of Media',
                key: 'percentOfMedia',
                value: '',
            },
            {
                displayName: 'Internal FB Ad Account ID',
                key: 'internalFBAdAccountId',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLAOneDay,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.RocketFuel,
        platformName: 'Rocket Fuel',
        platformKey: 'rocketfuel',
        partnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: 'sizmek rocketfuel',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
            {
                displayName: 'Rocket Fuel Account Manager',
                key: 'accountManager',
                value: '',
            },
        ],
        slas: {
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.RocketFuelLiveRamp,
        platformName: 'Rocket Fuel',
        platformKey: 'rocketfuel',
        partnerId: publicConstants.Partners.Oracle,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: 'sizmek rocketfuel',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
            {
                displayName: 'Rocket Fuel Account Manager',
                key: 'accountManager',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.LiveRamp,
        platformName: 'LiveRamp',
        platformKey: 'liveramp',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForInternalNewIntegrations: true,
        availableForExistingIntegrations: true,
        availableForExistingOrgIds: [482, 69],
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
            {
                displayName: 'LiveRamp Account Manager',
                key: 'accountManager',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.DataXu,
        platformName: 'OneView',
        platformKey: 'oneview',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
            {
                displayName: 'Account Id',
                key: 'accountId',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.MediaMath,
        platformName: 'MediaMath',
        platformKey: 'mediamath',
        partnerId: publicConstants.Partners.MediaMath,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        suppressCreateIntegration: true,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
            },
            {
                displayName: 'Permission Type',
                key: 'permissionType',
                value: '',
                options: [
                    {
                        display: 'Organization',
                        value: 'organization',
                    },
                    {
                        display: 'Agency',
                        value: 'agency',
                    },
                    {
                        display: 'Advertiser',
                        value: 'advertiser',
                    },
                ],
            },
            {
                displayName: 'Permission ID',
                key: 'permissionId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.AdTheorent,
        platformName: 'AdTheorent',
        platformKey: 'adtheorent',
        partnerId: publicConstants.Partners.AdTheorent,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
                optional: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLATwoToThreeDays,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.AdTheorentLR,
        platformName: 'AdTheorent',
        platformKey: 'adtheorent',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Client Name',
                key: 'clientName',
                value: '',
                primary: true,
            },
            {
                displayName: 'Client ID',
                key: 'clientId',
                value: '',
            },
            {
                displayName: 'AdTheorent Account Rep Email',
                key: 'accountRepEmail',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.VerveMobile,
        platformName: 'Verve Mobile',
        platformKey: 'vervemobile',
        partnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
                optional: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLATwoToThreeDays,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Digilant,
        platformName: 'Digilant',
        platformKey: 'digilant',
        partnerId: publicConstants.Partners.Digilant,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
                optional: true,
            },
        ],
        slas: {
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Netmining,
        platformName: 'Netmining',
        platformKey: 'netmining',
        partnerId: publicConstants.Partners.Netmining,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
                optional: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLAOneDay,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.TubeMogul,
        platformName: 'Adobe',
        platformKey: 'tubemogul',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: 'adobe advertising cloud',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
            },
            {
                displayName: 'Account Token',
                key: 'accountToken',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Krux,
        platformName: 'Krux',
        platformKey: 'krux',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: 'salesforce dmp salesforcedmp',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 'Client Name',
                key: 'clientName',
                value: '',
            },
            {
                displayName: 'Krux Account Manager Email',
                key: 'accountManagerEmail',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Adobe,
        platformName: 'Adobe',
        platformKey: 'adobe',
        partnerId: publicConstants.Partners.Adobe,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        suppressCreateIntegration: true,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 'Data Source Id',
                key: 'dataSourceId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.NativeTouch,
        platformName: 'NativeTouch',
        platformKey: 'nativetouch',
        partnerId: publicConstants.Partners.NativeTouch,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        suppressCreateIntegration: true,
        searchTerms: 'native touch',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLATwoToThreeDays,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Drawbridge,
        platformName: 'Drawbridge',
        platformKey: 'drawbridge',
        partnerId: publicConstants.Partners.Drawbridge,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLATwoToThreeDays,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Aki,
        platformName: 'Aki',
        platformKey: 'aki',
        partnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Agency Name',
                key: 'agencyName',
                value: '',
                primary: true,
            },
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLAThreeToFiveDays,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Snap,
        platformName: 'Snap - Direct',
        platformKey: 'snap',
        partnerId: publicConstants.Partners.Snap,
        availableForNewIntegrations: false,
        availableForInternalNewIntegrations: true,
        availableForExistingIntegrations: true,
        suppressCreateIntegration: true,
        searchTerms: 'snapchat',
        category: publicConstants.IntegrationCategories.Social.id,
        integrationInfo: [
            {
                displayName: 'Snap Ad Account Id',
                key: 'adAccountId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLAOneDay,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.SnapLiveRamp,
        platformName: 'Snap',
        platformKey: 'snapliveramp',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: true,
        availableForExistingIntegrations: true,
        suppressCreateIntegration: false,
        searchTerms: 'snapchat',
        category: publicConstants.IntegrationCategories.Social.id,
        alternatePricingMessage: 'Pricing will be set by your agreement with LiveRamp',
        note: 'Activate on social media platforms via a LiveRamp Advertiser Direct contract. Please work with a LiveRamp rep to set this up if not already in place. Pricing and reporting standards will be set according to your agreement.',
        integrationInfo: [
            {
                displayName: 'LiveRamp Account Name',
                key: 'liverampAccountName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Turn,
        platformName: 'Amobee',
        platformKey: 'turn',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: 'amobee',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Turn Market ID',
                key: 'turnMarketID',
                value: '',
            },
            {
                displayName: 'Turn Advertiser ID',
                key: 'turnAdvertiserID',
                value: '',
                primary: true,
            },
            {
                displayName: 'Agency Name',
                key: 'agencyName',
                value: '',
            },
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
            },
            {
                displayName: 'Turn Account Manager',
                key: 'accountManager',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Blis,
        platformName: 'Blis',
        platformKey: 'blis',
        partnerId: publicConstants.Partners.Blis,
        availableForNewIntegrations: true,
        availableForExistingIntegrations: true,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Seat Name',
                key: 'seatName',
                value: '',
                primary: true,
            },
            {
                displayName: 'Seat ID',
                key: 'seatId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLATwoToThreeDays,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.BlisLiveRamp,
        platformName: 'BlisLiveRamp',
        platformKey: 'blisLiveRamp',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        availableForExistingOrgIds: [],
        searchTerms: 'magenta, t-mobile, tms',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.BlisDirect,
        platformName: 'Magenta Audience Network',
        platformKey: 'blisdirect',
        partnerId: publicConstants.Partners.Blis,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: true,
        availableForExistingOrgIds: [1477, 1661, 1755, 1779, 1851, 1855, 1856, 1450, 69, 584],
        searchTerms: 'magenta, t-mobile, tads, tms',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.SLATwoToThreeDays,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.RhythmOne,
        platformName: 'RhythmOne',
        platformKey: 'rhythmone',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: 'radiumone',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Videology,
        platformName: 'Videology',
        platformKey: 'videology',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Adform,
        platformName: 'adform',
        platformKey: 'adform',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.LoopMe,
        platformName: 'LoopMe',
        platformKey: 'loopme',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.ThinkNear,
        platformName: 'ThinkNear',
        platformKey: 'thinknear',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Jampp,
        platformName: 'Jampp',
        platformKey: 'jampp',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Beeswax,
        platformName: 'Beeswax',
        platformKey: 'beeswax',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
            {
                displayName: 'Buzzkey',
                key: 'buzzkey',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.LiveIntent,
        platformName: 'LiveIntent',
        platformKey: 'liveintent',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Avocet,
        platformName: 'Avocet',
        platformKey: 'avocet',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.PlaceIQ,
        platformName: 'PlaceIQ',
        platformKey: 'placeiq',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.OwnerIQ,
        platformName: 'OwnerIQ',
        platformKey: 'owneriq',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
            {
                displayName: 'OwnerIQ Account Manager Email',
                key: 'accountManagerEmail',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Valassis,
        platformName: 'Valassis',
        platformKey: 'valassis',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: 'Maxpoint',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Vistar,
        platformName: 'Vistar',
        platformKey: 'vistar',
        partnerId: publicConstants.Partners.Vistar,
        availableForNewIntegrations: true,
        availableForExistingIntegrations: true,
        availableForExistingOrgIds: [1615, 672, 542, 87, 1662],
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Dooh,
        platformName: 'Magenta Audience Network - DOOH',
        platformKey: 'dooh',
        partnerId: publicConstants.Partners.Vistar,
        availableForNewIntegrations: false,
        availableForInternalNewIntegrations: true,
        availableForExistingIntegrations: true,
        suppressCreateIntegration: true,
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Smadex,
        platformName: 'Smadex',
        platformKey: 'smadex',
        partnerId: publicConstants.Partners.Smadex,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
            {
                displayName: 'Smadex Account Id',
                key: 'accountId',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.PushSpringManual,
        platformName: 'PushSpring Manual',
        platformKey: 'pushspring',
        partnerId: publicConstants.Partners.Manual,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: true,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: { message: 'Contact PushSpring', days: 1 },
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Neustar,
        platformName: 'Neustar',
        platformKey: 'neustar',
        partnerId: publicConstants.Partners.Neustar,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Ubimo,
        platformName: 'Ubimo',
        platformKey: 'ubimo',
        partnerId: publicConstants.Partners.Ubimo,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Nielsen,
        platformName: 'Nielsen',
        platformKey: 'nielsen',
        partnerId: publicConstants.Partners.Nielsen,
        availableForNewIntegrations: false,
        availableForInternalNewIntegrations: true,
        availableForExistingIntegrations: false,
        availableForExistingOrgIds: [482, 69],
        searchTerms: 'exelate',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 's3 Prefix',
                key: 's3Prefix',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Teads,
        platformName: 'Teads.tv',
        platformKey: 'teads',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: 'Teads',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Teads ID',
                key: 'teadsId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.PlatformIO,
        platformName: 'Platform.io',
        platformKey: 'platformio',
        partnerId: publicConstants.Partners.PlatformIO,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: 'platform.io',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Dstillery,
        platformName: 'Dstillery',
        platformKey: 'dstillery',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Namespace Check Value',
                key: 'ncv',
                value: '',
            },
            {
                displayName: 'Namespace ID',
                key: 'ns',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Hulu,
        platformName: 'Hulu',
        platformKey: 'hulu',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Tremor,
        platformName: 'Tremor',
        platformKey: 'tremor',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Scope,
        platformName: 'Media Ocean',
        platformKey: 'scope',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DMP.id,
        integrationInfo: [
            {
                displayName: 'Brand Profile Id',
                key: 'brandProfileId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Pinterest,
        platformName: 'Pinterest',
        platformKey: 'pinterest',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: true,
        availableForExistingIntegrations: true,
        suppressCreateIntegration: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.Social.id,
        alternatePricingMessage: 'Pricing will be set by your agreement with LiveRamp',
        note: 'Activate on social media platforms via a LiveRamp Advertiser Direct contract. Please work with a LiveRamp rep to set this up if not already in place. Pricing and reporting standards will be set according to your agreement.',
        integrationInfo: [
            {
                displayName: 'LiveRamp Account Name',
                key: 'liverampAccountName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.AmazonAdvertising,
        platformName: 'Amazon Advertising',
        platformKey: 'amazonAdvertising',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForInternalNewIntegrations: true,
        availableForExistingIntegrations: false,
        availableForExistingOrgIds: [285, 1324, 482, 69],
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Amazon Advertiser ID',
                key: 'amazonAdvertiserId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.FacebookLiveRamp,
        platformName: 'FacebookLiveRamp',
        platformKey: 'facebookliveramp',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: 'instagram',
        category: publicConstants.IntegrationCategories.Social.id,
        integrationInfo: [],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        // Intended for bizdev to send data to NinthDecimal for experimentation.  Should
        // not be made public as this just dumps to S3
        type: publicConstants.ExternalIntegrations.Type.NinthDecimal,
        platformName: 'NinthDecimal (BizDev Only)',
        platformKey: 'ninthdecimal',
        partnerId: publicConstants.Partners.NinthDecimal,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Experiment Name',
                key: 'experimentName',
                value: '',
                primary: true,
                optional: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: { message: 'Contact PushSpring', days: 1 },
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.TMobileAudienceNetwork,
        platformName: 'Magenta Audience Network',
        platformKey: 'tmobileaudiencenetwork',
        partnerId: publicConstants.Partners.MediaMath,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        suppressCreateIntegration: true,
        searchTerms: 'magenta, t-mobile, tms',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Spotify,
        platformName: 'Spotify',
        platformKey: 'spotify',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
            {
                displayName: 'Spotify Account Manager Email',
                key: 'accountManagerEmail',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.JunGroup,
        platformName: 'Jun Group',
        platformKey: 'jungroup',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.SimpliFi,
        platformName: 'Simpli.Fi',
        platformKey: 'simplifi',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Simpli.Fi Account Name',
                key: 'accountName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.TremorVideo,
        platformName: 'Tremor Video',
        platformKey: 'tremorvideo',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Tremor Video Account Name',
                key: 'accountName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Alphonso,
        platformName: 'Alphonso',
        platformKey: 'alphonso',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Account Id',
                key: 'accountId',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.StackAdapt,
        platformName: 'StackAdapt',
        platformKey: 'stackadapt',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Kargo,
        platformName: 'Kargo',
        platformKey: 'kargo',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.DigitalTurbine,
        platformName: 'Digital Turbine',
        platformKey: 'digitalturbine',
        partnerId: publicConstants.Partners.DigitalTurbine,
        availableForNewIntegrations: false,
        availableForExistingIntegrations: false,
        suppressCreateIntegration: true,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Advertiser Name',
                key: 'advertiserName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.FacebookLiveRampV2,
        platformName: 'Facebook',
        platformKey: 'facebookliverampv2',
        partnerId: publicConstants.Partners.Acxiom,
        cookiePartnerId: publicConstants.Partners.Acxiom,
        cookieAndDevicePartnerId: publicConstants.Partners.Acxiom,
        availableForNewIntegrations: true,
        availableForExistingIntegrations: true,
        suppressCreateIntegration: false,
        searchTerms: 'instagram',
        category: publicConstants.IntegrationCategories.Social.id,
        alternatePricingMessage: 'Pricing will be set by your agreement with LiveRamp',
        note: 'Activate on social media platforms via a LiveRamp Advertiser Direct contract. Please work with a LiveRamp rep to set this up if not already in place. Pricing and reporting standards will be set according to your agreement.',
        integrationInfo: [
            {
                displayName: 'LiveRamp Account Name',
                key: 'liverampAccountName',
                value: '',
                primary: true,
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.StartIO,
        platformName: 'StartIO',
        platformKey: 'startio',
        partnerId: publicConstants.Partners.StartIO,
        availableForNewIntegrations: true,
        availableForInternalNewIntegrations: true,
        availableForExistingIntegrations: true,
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Account Name',
                key: 'startioAccountName',
                value: '',
                primary: true,
            },
            {
                displayName: 'Token',
                key: 'startioToken',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.Martin,
        platformName: 'Magenta Audience Network - Martin',
        platformKey: 'martin',
        partnerId: publicConstants.Partners.Martin,
        availableForNewIntegrations: false,
        availableForInternalNewIntegrations: true,
        availableForExistingIntegrations: true,
        suppressCreateIntegration: true,
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [
            {
                displayName: 'Account Name',
                key: 'accountName',
                value: '',
                primary: true,
            },
            {
                displayName: 'Advertiser Id',
                key: 'advertiserId',
                value: '',
            },
        ],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.AudienceApiSliide,
        platformName: 'Audience API Sliide',
        platformKey: 'audience-api-sliide',
        partnerId: publicConstants.Partners.AudienceApiSliide,
        availableForNewIntegrations: false,
        availableForInternalNewIntegrations: true,
        availableForExistingIntegrations: true,
        suppressCreateIntegration: true,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
    {
        type: publicConstants.ExternalIntegrations.Type.AudienceApiUnity,
        platformName: 'Audience API Unity',
        platformKey: 'audience-api-unity',
        partnerId: publicConstants.Partners.AudienceApiUnity,
        availableForNewIntegrations: false,
        availableForInternalNewIntegrations: true,
        availableForExistingIntegrations: true,
        suppressCreateIntegration: true,
        searchTerms: '',
        category: publicConstants.IntegrationCategories.DSP.id,
        integrationInfo: [],
        slas: {
            // These keys reference the values in publicConstants.PartnerTransmitSegmentSchedules.Type
            0: publicConstants.standardSLA,
            1: publicConstants.standardSLA,
            2: publicConstants.standardSLA,
        },
    },
];

// Partner Data ingestion constants
publicConstants.PartnerIngestion = {
    KeyType: {
        PushSpring: 0,
        PartnerForeignKey: 1,
    },
    PathType: {
        PushSpring: 0,
        PartnerS3: 1,
        DDT: 2,
    },
    LogType: {
        Import: 0,
        Delete: 1,
        LiveRamp: 2,
        LiveRampV2: 3,
        // HashedMSISDN: 4, // No longer valid. Implementation removed
    },
};

publicConstants.PSGenres = {};
publicConstants.PSGenres.BooksReference = 10;
publicConstants.PSGenres.Business = 11;
publicConstants.PSGenres.Education = 12;
publicConstants.PSGenres.Entertainment = 13;
publicConstants.PSGenres.Finance = 14;
publicConstants.PSGenres.HealthFitness = 15;
publicConstants.PSGenres.LifestyleFood = 16;
publicConstants.PSGenres.Medical = 17;
publicConstants.PSGenres.MusicAudio = 18;
publicConstants.PSGenres.TransportationNavigation = 19;
publicConstants.PSGenres.NewsMagazines = 20;
publicConstants.PSGenres.PhotoVideo = 21;
publicConstants.PSGenres.Productivity = 22;
publicConstants.PSGenres.SocialCommunications = 23;
publicConstants.PSGenres.Sports = 24;
publicConstants.PSGenres.TravelLocal = 25;
publicConstants.PSGenres.Utilities = 26;
publicConstants.PSGenres.Weather = 27;
publicConstants.PSGenres.Games = 28;
publicConstants.PSGenres.Shopping = 29;
// Games
publicConstants.PSGameGenres = {};
publicConstants.PSGameGenres.Action = 60;
publicConstants.PSGameGenres.Adventure = 61;
publicConstants.PSGameGenres.Arcade = 62;
publicConstants.PSGameGenres.Board = 63;
publicConstants.PSGameGenres.Card = 64;
publicConstants.PSGameGenres.Casino = 65;
publicConstants.PSGameGenres.Casual = 66;
publicConstants.PSGameGenres.Educational = 67;
publicConstants.PSGameGenres.Family = 68;
//publicConstants.PSGameGenres.Kids= 69;
publicConstants.PSGameGenres.Music = 70;
publicConstants.PSGameGenres.Puzzle = 71;
publicConstants.PSGameGenres.Racing = 72;
publicConstants.PSGameGenres.RolePlaying = 73;
publicConstants.PSGameGenres.Simulation = 74;
publicConstants.PSGameGenres.GamesSports = 75;
publicConstants.PSGameGenres.Strategy = 76;
publicConstants.PSGameGenres.Trivia = 77;
publicConstants.PSGameGenres.Word = 78;

publicConstants.MobileApps = {};
publicConstants.MobileApps.Genre = [
    {
        genre_id: publicConstants.PSGenres.BooksReference,
        pushspring: 'Books & Reference',
        itunes: [6018 /*'Book'*/, 6006 /*'Reference'*/, 6022 /*'Catalogs'*/],
        play: ['BOOKS_AND_REFERENCE', 'COMICS'],
    },
    {
        genre_id: publicConstants.PSGenres.Business,
        pushspring: 'Business',
        itunes: [6000 /*'Business'*/],
        play: ['BUSINESS'],
    },
    {
        genre_id: publicConstants.PSGenres.Education,
        pushspring: 'Education',
        itunes: [6017 /*'Education'*/],
        play: ['EDUCATION', 'FAMILY_EDUCATION'],
    },
    {
        genre_id: publicConstants.PSGenres.Entertainment,
        pushspring: 'Entertainment',
        itunes: [6016 /*'Entertainment'*/],
        play: ['ENTERTAINMENT'],
    },
    {
        genre_id: publicConstants.PSGenres.Finance,
        pushspring: 'Finance',
        itunes: [6015 /*'Finance'*/],
        play: ['FINANCE'],
    },
    {
        genre_id: publicConstants.PSGenres.HealthFitness,
        pushspring: 'Health & Fitness',
        itunes: [6013 /*'Health & Fitness'*/],
        play: ['HEALTH_AND_FITNESS'],
    },
    {
        genre_id: publicConstants.PSGenres.LifestyleFood,
        pushspring: 'Lifestyle & Food',
        itunes: [6012 /*'Lifestyle'*/, 6023 /*'Food & Drink'*/],
        play: ['LIFESTYLE', 'DATING', 'BEAUTY', 'HOUSE_AND_HOME', 'FOOD_AND_DRINK'],
    },
    {
        genre_id: publicConstants.PSGenres.Medical,
        pushspring: 'Medical',
        itunes: [6020 /* 'Medical' */],
        play: ['MEDICAL'],
    },
    {
        genre_id: publicConstants.PSGenres.MusicAudio,
        pushspring: 'Music & Audio',
        itunes: [6011 /*'Music'*/],
        play: ['MUSIC_AND_AUDIO'],
    },
    {
        genre_id: publicConstants.PSGenres.TransportationNavigation,
        pushspring: 'Transportation & Navigation',
        itunes: [6010 /*'Navigation'*/],
        play: ['MAPS_AND_NAVIGATION'],
    },
    {
        genre_id: publicConstants.PSGenres.NewsMagazines,
        pushspring: 'News & Magazines',
        itunes: [6009 /*'News'*/, 6021 /*'Newsstand'*/],
        play: ['NEWS_AND_MAGAZINES'],
    },
    {
        genre_id: publicConstants.PSGenres.PhotoVideo,
        pushspring: 'Photo & Video',
        itunes: [6008 /*'Photo & Video'*/],
        play: ['PHOTOGRAPHY', 'VIDEO_PLAYERS'],
    },
    {
        genre_id: publicConstants.PSGenres.Productivity,
        pushspring: 'Productivity',
        itunes: [6007 /*'Productivity'*/],
        play: ['PRODUCTIVITY'],
    },
    {
        genre_id: publicConstants.PSGenres.SocialCommunications,
        pushspring: 'Social & Communications',
        itunes: [6005 /*'Social Networking'*/],
        play: ['SOCIAL', 'COMMUNICATION'],
    },
    { genre_id: publicConstants.PSGenres.Sports, pushspring: 'Sports', itunes: [6004 /*'Sports'*/], play: ['SPORTS'] },
    {
        genre_id: publicConstants.PSGenres.TravelLocal,
        pushspring: 'Travel & Local',
        itunes: [6003 /*'Travel'*/],
        play: ['TRAVEL_AND_LOCAL'],
    },
    {
        genre_id: publicConstants.PSGenres.Utilities,
        pushspring: 'Utilities',
        itunes: [6002 /*'Utilities'*/],
        play: ['PERSONALIZATION', 'ANDROID_WEAR', 'TOOLS', 'EVENTS', 'LIBRARIES_AND_DEMO'],
    },
    {
        genre_id: publicConstants.PSGenres.Weather,
        pushspring: 'Weather',
        itunes: [6001 /*'Weather'*/],
        play: ['WEATHER'],
    },
    { genre_id: publicConstants.PSGenres.Games, pushspring: 'Games', itunes: [6014 /*'Games'*/], play: ['GAME'] },
    {
        genre_id: publicConstants.PSGenres.Shopping,
        pushspring: 'Shopping',
        itunes: [1472, 6024 /*'Shopping'*/],
        play: ['SHOPPING', 'AUTO_AND_VEHICLES'],
    },
    // Games
    { genre_id: publicConstants.PSGameGenres.Action, pushspring: 'Action', itunes: [7001], play: ['GAME_ACTION'] },
    {
        genre_id: publicConstants.PSGameGenres.Adventure,
        pushspring: 'Adventure',
        itunes: [7002],
        play: ['GAME_ADVENTURE'],
    },
    { genre_id: publicConstants.PSGameGenres.Arcade, pushspring: 'Arcade', itunes: [7003], play: ['GAME_ARCADE'] },
    { genre_id: publicConstants.PSGameGenres.Board, pushspring: 'Board', itunes: [7004], play: ['GAME_BOARD'] },
    { genre_id: publicConstants.PSGameGenres.Card, pushspring: 'Card', itunes: [7005], play: ['GAME_CARD'] },
    {
        genre_id: publicConstants.PSGameGenres.Casino,
        pushspring: 'Casino',
        itunes: [7006, 7007],
        play: ['GAME_CASINO'],
    },
    { genre_id: publicConstants.PSGameGenres.Casual, pushspring: 'Casual', itunes: [], play: ['GAME_CASUAL'] },
    {
        genre_id: publicConstants.PSGameGenres.Educational,
        pushspring: 'Educational',
        itunes: [7008],
        play: ['GAME_EDUCATIONAL'],
    },
    {
        genre_id: publicConstants.PSGameGenres.Family,
        pushspring: 'Family',
        itunes: [7009],
        play: ['FAMILY', 'PARENTING'],
    },
    //{ genre_id: publicConstants.PSGameGenres.Kids, pushspring:'Kids', itunes:[], play:['Kids']},
    { genre_id: publicConstants.PSGameGenres.Music, pushspring: 'Music', itunes: [7011], play: ['GAME_MUSIC'] },
    { genre_id: publicConstants.PSGameGenres.Puzzle, pushspring: 'Puzzle', itunes: [7012], play: ['GAME_PUZZLE'] },
    { genre_id: publicConstants.PSGameGenres.Racing, pushspring: 'Racing', itunes: [7013], play: ['GAME_RACING'] },
    {
        genre_id: publicConstants.PSGameGenres.RolePlaying,
        pushspring: 'Role Playing',
        itunes: [7014],
        play: ['GAME_ROLE_PLAYING'],
    },
    {
        genre_id: publicConstants.PSGameGenres.Simulation,
        pushspring: 'Simulation',
        itunes: [7015],
        play: ['GAME_SIMULATION'],
    },
    { genre_id: publicConstants.PSGameGenres.GamesSports, pushspring: 'Sports', itunes: [7016], play: ['GAME_SPORTS'] },
    {
        genre_id: publicConstants.PSGameGenres.Strategy,
        pushspring: 'Strategy',
        itunes: [7017],
        play: ['GAME_STRATEGY'],
    },
    { genre_id: publicConstants.PSGameGenres.Trivia, pushspring: 'Trivia', itunes: [7018], play: ['GAME_TRIVIA'] },
    { genre_id: publicConstants.PSGameGenres.Word, pushspring: 'Word', itunes: [7019], play: ['GAME_WORD'] },
];

// Dynamically generated and cached maps to map iTunes or Play genres to PushSpring ones
const _iTunesToGenre = {};
publicConstants.MobileApps.Genre.forEach((genre) => {
    genre.itunes.forEach((itunes_genre) => {
        _iTunesToGenre[itunes_genre] = genre.genre_id;
    });
});
publicConstants.MobileApps.MapITunesGenreToPushSpringGenre = _iTunesToGenre;

let _playToGenre;
_playToGenre = {};
publicConstants.MobileApps.Genre.forEach((genre) => {
    genre.play.forEach((play_genre) => {
        _playToGenre[play_genre] = genre.genre_id;
    });
});
publicConstants.MobileApps.MapPlayGenreToPushSpringGenre = _playToGenre;

const _genreIdToGenre = {};
publicConstants.MobileApps.Genre.forEach((genre) => {
    _genreIdToGenre[genre.genre_id] = genre;
});
publicConstants.MobileApps.MapGenreIdtoGenre = _genreIdToGenre;

publicConstants.RollupSegments = {};
publicConstants.RollupSegments[70000] = 'PushSpring Fraud-Free Mobile App Data';
publicConstants.RollupSegments[71000] = 'Intent';
publicConstants.RollupSegments[71001] = 'Intent > Automotive & Boating';
publicConstants.RollupSegments[71002] = 'Intent > Events';
publicConstants.RollupSegments[71003] = 'Intent > Fashion';
publicConstants.RollupSegments[71010] = 'Intent > Health & Fitness';
publicConstants.RollupSegments[71004] = 'Intent > Pharmaceutical';
publicConstants.RollupSegments[71005] = 'Intent > Professional Services';
publicConstants.RollupSegments[71006] = 'Intent > Real Estate';
publicConstants.RollupSegments[71007] = 'Intent > Retail';
publicConstants.RollupSegments[71008] = 'Intent > Technology';
publicConstants.RollupSegments[71009] = 'Intent > Travel';
publicConstants.RollupSegments[72000] = 'Interest & Activity';
publicConstants.RollupSegments[72001] = 'Interest & Activity > Arts & Entertainment';
publicConstants.RollupSegments[72002] = 'Interest & Activity > Automotive & Boating';
publicConstants.RollupSegments[72003] = 'Interest & Activity > Communications';
publicConstants.RollupSegments[72004] = 'Interest & Activity > Environment';
publicConstants.RollupSegments[72005] = 'Interest & Activity > Financial Services';
publicConstants.RollupSegments[72006] = 'Interest & Activity > Food & Restaurants';
publicConstants.RollupSegments[72007] = 'Interest & Activity > Gaming';
publicConstants.RollupSegments[72008] = 'Interest & Activity > Health & Fitness';
publicConstants.RollupSegments[72009] = 'Interest & Activity > Home & Garden';
publicConstants.RollupSegments[72010] = 'Interest & Activity > News';
publicConstants.RollupSegments[72011] = 'Interest & Activity > Sports & Recreation';
publicConstants.RollupSegments[72012] = 'Interest & Activity > Technology';
publicConstants.RollupSegments[72013] = 'Interest & Activity > Telecommunications';
publicConstants.RollupSegments[72014] = 'Interest & Activity > Travel';
publicConstants.RollupSegments[72015] = 'Interest & Activity > Sharing Economy';
publicConstants.RollupSegments[72016] = 'Interest & Activity > Video Streaming';
publicConstants.RollupSegments[72017] = 'Interest & Activity > On Demand';
publicConstants.RollupSegments[72018] = 'Interest & Activity > Politics';
publicConstants.RollupSegments[73000] = 'Life Stage';
publicConstants.RollupSegments[73002] = 'Life Stage > Business';
publicConstants.RollupSegments[73003] = 'Life Stage > Education';
publicConstants.RollupSegments[73004] = 'Life Stage > Family Status';
publicConstants.RollupSegments[73005] = 'Life Stage > Financial Services';
publicConstants.RollupSegments[73006] = 'Life Stage > Lifestyle';
publicConstants.RollupSegments[73007] = 'Life Stage > Marital Status';
publicConstants.RollupSegments[73008] = 'Life Stage > Real Estate';
publicConstants.RollupSegments[73009] = 'Life Stage > Generations';
publicConstants.RollupSegments[74000] = 'Demographic';
publicConstants.RollupSegments[74001] = 'Demographic > Gender';
publicConstants.RollupSegments[74002] = 'Demographic > Language';
publicConstants.RollupSegments[74003] = 'Demographic > Total HH Income';
publicConstants.RollupSegments[74004] = 'Demographic > Age';
publicConstants.RollupSegments[75000] = 'Apps Owned By Genre';
publicConstants.RollupSegments[75001] = 'Apps Owned By Genre > Game';
publicConstants.RollupSegments[76000] = 'Deprecated PushSpring Demographic';
publicConstants.RollupSegments[76001] = 'Deprecated PushSpring Demographic > Age';
publicConstants.RollupSegments[76002] = 'Deprecated PushSpring Demographic > Gender';
publicConstants.RollupSegments[76003] = 'Deprecated PushSpring Demographic > Total HH Income';
publicConstants.RollupSegments[77000] = 'Single App';
publicConstants.RollupSegments[77010] = 'Books & Reference';
publicConstants.RollupSegments[77011] = 'Business';
publicConstants.RollupSegments[77012] = 'Education';
publicConstants.RollupSegments[77013] = 'Entertainment';
publicConstants.RollupSegments[77014] = 'Finance';
publicConstants.RollupSegments[77015] = 'Health & Fitness';
publicConstants.RollupSegments[77016] = 'Lifestyle & Food';
publicConstants.RollupSegments[77017] = 'Medical';
publicConstants.RollupSegments[77018] = 'Music & Audio';
publicConstants.RollupSegments[77019] = 'Transportation & Navigation';
publicConstants.RollupSegments[77020] = 'News & Magazines';
publicConstants.RollupSegments[77021] = 'Photo & Video';
publicConstants.RollupSegments[77022] = 'Productivity';
publicConstants.RollupSegments[77023] = 'Social & Communications';
publicConstants.RollupSegments[77024] = 'Sports';
publicConstants.RollupSegments[77025] = 'Travel & Local';
publicConstants.RollupSegments[77026] = 'Utilities';
publicConstants.RollupSegments[77027] = 'Weather';
publicConstants.RollupSegments[77028] = 'Games';
publicConstants.RollupSegments[77029] = 'Shopping';
publicConstants.RollupSegments[77060] = 'Action';
publicConstants.RollupSegments[77061] = 'Adventure';
publicConstants.RollupSegments[77062] = 'Arcade';
publicConstants.RollupSegments[77063] = 'Board';
publicConstants.RollupSegments[77064] = 'Card';
publicConstants.RollupSegments[77065] = 'Casino';
publicConstants.RollupSegments[77066] = 'Casual';
publicConstants.RollupSegments[77067] = 'Educational';
publicConstants.RollupSegments[77068] = 'Family';
publicConstants.RollupSegments[77070] = 'Music';
publicConstants.RollupSegments[77071] = 'Puzzle';
publicConstants.RollupSegments[77072] = 'Racing';
publicConstants.RollupSegments[77073] = 'Role Playing';
publicConstants.RollupSegments[77074] = 'Simulation';
publicConstants.RollupSegments[77075] = 'Sports';
publicConstants.RollupSegments[77076] = 'Strategy';
publicConstants.RollupSegments[77077] = 'Trivia';
publicConstants.RollupSegments[77078] = 'Word';
publicConstants.RollupSegments[78000] = 'Device Attributes';
publicConstants.RollupSegments[78100] = 'Device Attributes > Carriers';
publicConstants.RollupSegments[78200] = 'Device Attributes > Manufacturers';
publicConstants.RollupSegments[78300] = 'Device Attributes > Age';
publicConstants.RollupSegments[78400] = 'Device Attributes > Performance';

let _personaSegments = null;
function _getPersonaSegments() {
    if (!_personaSegments) {
        _personaSegments = {};

        Object.values(publicConstants.TaxonomyHierarchy['70000']).forEach((rollupLevel1) => {
            Object.entries(rollupLevel1).forEach(([rollupLevel2Id, rollupLevel2]) => {
                const rollupName = publicConstants.RollupSegments[rollupLevel2Id].replace(' > ', ' - ');
                // Don't include synthetic personas
                if (!['74001', '74003', '74004'].includes(rollupLevel2Id)) {
                    if (!_personaSegments[rollupName]) {
                        _personaSegments[rollupName] = [];
                    }
                    _personaSegments[rollupName].push.apply(_personaSegments[rollupName], rollupLevel2);
                }
            });
        });

        Object.entries(publicConstants.TaxonomyHierarchy['78000']).forEach(([rollupLevel1Id, rollupLevel1]) => {
            const rollupName = publicConstants.RollupSegments[rollupLevel1Id].replace(' > ', ' - ');
            if (!_personaSegments[rollupName]) {
                _personaSegments[rollupName] = [];
            }
            _personaSegments[rollupName].push.apply(_personaSegments[rollupName], rollupLevel1);
        });
    }

    return _personaSegments;
}

Object.defineProperty(publicConstants, 'PersonaSegments', {
    get: _getPersonaSegments,
    enumerable: true,
    configurable: false,
});

publicConstants.Age = {
    Unknown: 0,
    '18-24': 1,
    '25-34': 2,
    '35-44': 3,
    '45-54': 4,
    '55-64': 5,
    '65+': 6,
};

publicConstants.DisplayAge = [
    { name: '18 - 24', key: '18-24' },
    { name: '25 - 34', key: '25-34' },
    { name: '35 - 44', key: '35-44' },
    { name: '45 - 54', key: '45-54' },
    { name: '55 - 64', key: '55-64' },
    { name: '65+', key: '65+' },
];

publicConstants.Income = {
    Unknown: 0,
    Under25K: 1,
    '25K-39K': 2,
    '40K-59K': 3,
    '60K-74K': 4,
    '75K-100K': 5,
    Over100K: 6,
};

publicConstants.DisplayIncome = [
    { name: 'Over $100k', key: 'Over100K' },
    { name: '$75k - $100k', key: '75K-100K' },
    { name: '$60k - $75k', key: '60K-74K' },
    { name: '$40k - $60k', key: '40K-59K' },
    { name: '$25k - $40k', key: '25K-39K' },
    { name: 'Under $25k', key: 'Under25K' },
];

// These buckets are the new values returned by the
// pushspringDemographicModels in the classifier.
publicConstants.PushSpringIncome = {
    Unknown: 0,
    '<35k': 1,
    '35-50k': 2,
    '50-75k': 3,
    '75-100k': 4,
    '100-150k': 5,
    '150k+': 6,
};

// Megan insisted on overlapping buckets after a long
// discussion on 6/21/18
// "I would like to just leave them as that is how the data are labeled."
publicConstants.PushSpringDisplayIncome = [
    { name: 'Over $150k', key: '150k+' },
    { name: '$100k - $150k', key: '100-150k' },
    { name: '$75k - $100k', key: '75-100k' },
    { name: '$50k - $75k', key: '50-75k' },
    { name: '$35k - $50k', key: '35-50k' },
    { name: 'Under $35k', key: '<35k' },
];

publicConstants.PushSpringIncomeMedian = {};
publicConstants.PushSpringIncomeMedian[publicConstants.PushSpringIncome.Unknown] = null;
publicConstants.PushSpringIncomeMedian[publicConstants.PushSpringIncome['<35k']] = 13500;
publicConstants.PushSpringIncomeMedian[publicConstants.PushSpringIncome['35-50k']] = 42500;
publicConstants.PushSpringIncomeMedian[publicConstants.PushSpringIncome['50-75k']] = 62500;
publicConstants.PushSpringIncomeMedian[publicConstants.PushSpringIncome['75-100k']] = 87500;
publicConstants.PushSpringIncomeMedian[publicConstants.PushSpringIncome['100-150k']] = 125000;
publicConstants.PushSpringIncomeMedian[publicConstants.PushSpringIncome['150k+']] = 162500;

// Values stored in the tads_gender and tads_age calculated attributes, populated from the
// first-party demographic predictions view provided by Data Science.
publicConstants.TAdsGender = {
    Unknown: 0,
    Male: 1,
    Female: 2,
};

publicConstants.TAdsAge = {
    Unknown: 0,
    '<25': 1,
    '25-34': 2,
    '35-54': 3,
    '55+': 4,
};

publicConstants.DisplayTimeOfDay = [
    { name: '12 am - 8 am', key: '12am-8am' },
    { name: '8 am - 4 pm', key: '8am-4pm' },
    { name: '4 pm - 12 am', key: '4pm-12am' },
];

publicConstants.DisplayPlatform = [
    { name: 'Android', key: 'Android' },
    { name: 'iOS', key: 'iOS' },
];

publicConstants.DisplayGender = [
    { name: 'Male', key: 'Male' },
    { name: 'Female', key: 'Female' },
];

// Flattened
// Persona is auto-generated in R //
publicConstants.Personas = {
    101: {
        _id: 101,
        name: 'Business Professionals',
        hidden: false,
        persona_type: 'lifestage',
    },
    102: {
        _id: 102,
        name: 'Home Financial Planners',
        hidden: false,
        persona_type: 'interest',
    },
    103: {
        _id: 103,
        name: 'Home Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    104: {
        _id: 104,
        name: 'Small Business Owners',
        hidden: false,
        persona_type: 'lifestage',
    },
    201: {
        _id: 201,
        name: 'Business Travelers',
        hidden: false,
        persona_type: 'interest',
    },
    202: {
        _id: 202,
        name: 'Vacationers',
        hidden: false,
        persona_type: 'interest',
    },
    302: {
        _id: 302,
        name: 'Mobile Payment Makers',
        hidden: false,
        persona_type: 'interest',
    },
    303: {
        _id: 303,
        name: 'Bargain Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    304: {
        _id: 304,
        name: 'Auto Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    305: {
        _id: 305,
        name: 'Coupon Clippers',
        hidden: false,
        persona_type: 'intent',
    },
    401: {
        _id: 401,
        name: 'Sports Fans',
        hidden: false,
        persona_type: 'interest',
    },
    402: {
        _id: 402,
        name: 'Health & Fitness Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    403: {
        _id: 403,
        name: 'Avid Runners',
        hidden: false,
        persona_type: 'interest',
    },
    404: {
        _id: 404,
        name: 'Avid Cyclists',
        hidden: false,
        persona_type: 'interest',
    },
    405: {
        _id: 405,
        name: 'Avid Skiers',
        hidden: false,
        persona_type: 'interest',
    },
    406: {
        _id: 406,
        name: 'Fitness Device Owners',
        hidden: false,
        persona_type: 'interest',
    },
    407: {
        _id: 407,
        name: 'American Football Fans',
        hidden: false,
        persona_type: 'interest',
    },
    408: {
        _id: 408,
        name: 'Baseball Fans',
        hidden: false,
        persona_type: 'interest',
    },
    409: {
        _id: 409,
        name: 'Basketball Fans',
        hidden: false,
        persona_type: 'interest',
    },
    410: {
        _id: 410,
        name: 'College Sports Fans',
        hidden: false,
        persona_type: 'interest',
    },
    411: {
        _id: 411,
        name: 'College Football Fans',
        hidden: false,
        persona_type: 'interest',
    },
    412: {
        _id: 412,
        name: 'College Basketball Fans',
        hidden: false,
        persona_type: 'interest',
    },
    501: {
        _id: 501,
        name: 'Avid Readers',
        hidden: false,
        persona_type: 'interest',
    },
    502: {
        _id: 502,
        name: 'Social & Casual Gamers',
        hidden: false,
        persona_type: 'interest',
    },
    504: {
        _id: 504,
        name: 'Hardcore Gamers',
        hidden: false,
        persona_type: 'interest',
    },
    505: {
        _id: 505,
        name: 'Movie Buffs',
        hidden: false,
        persona_type: 'interest',
    },
    506: {
        _id: 506,
        name: 'Music Lovers',
        hidden: false,
        persona_type: 'interest',
    },
    508: {
        _id: 508,
        name: 'Casino App Players',
        hidden: false,
        persona_type: 'interest',
    },
    509: {
        _id: 509,
        name: 'Card & Board Gamers',
        hidden: false,
        persona_type: 'interest',
    },
    510: {
        _id: 510,
        name: 'TV Geeks',
        hidden: true,
        skip_calc: true,
        persona_type: 'interest',
    },
    512: {
        _id: 512,
        name: 'News Readers',
        hidden: false,
        persona_type: 'interest',
    },
    513: {
        _id: 513,
        name: 'e-News Readers',
        hidden: false,
        persona_type: 'interest',
    },
    514: {
        _id: 514,
        name: 'Casino Visitors',
        hidden: false,
        persona_type: 'interest',
    },
    515: {
        _id: 515,
        name: 'Mobile Gamers',
        hidden: false,
        persona_type: 'interest',
    },
    601: {
        _id: 601,
        name: 'Auto Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    602: {
        _id: 602,
        name: 'Designer Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    603: {
        _id: 603,
        name: 'Foodies',
        hidden: false,
        persona_type: 'interest',
    },
    604: {
        _id: 604,
        name: 'This persona no longer exists',
        hidden: true,
        skip_calc: true,
        persona_type: 'lifestage',
    },
    605: {
        _id: 605,
        name: 'Home & Garden Pros',
        hidden: false,
        persona_type: 'interest',
    },
    606: {
        _id: 606,
        name: 'This persona no longer exists',
        hidden: true,
        skip_calc: true,
        persona_type: 'demographic',
    },
    607: {
        _id: 607,
        name: 'New Moms',
        hidden: false,
        persona_type: 'lifestage',
    },
    608: {
        _id: 608,
        name: 'Parents',
        hidden: false,
        persona_type: 'lifestage',
    },
    609: {
        _id: 609,
        name: 'Pet Owners',
        hidden: false,
        persona_type: 'lifestage',
    },
    610: {
        _id: 610,
        name: 'Photo & Video Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    611: {
        _id: 611,
        name: 'Singles',
        hidden: false,
        persona_type: 'lifestage',
    },
    612: {
        _id: 612,
        name: 'Social Influencers',
        hidden: false,
        persona_type: 'interest',
    },
    613: {
        _id: 613,
        name: 'Spanish Speakers',
        hidden: false,
        persona_type: 'language',
    },
    614: {
        _id: 614,
        name: 'Tech & Gadget Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    616: {
        _id: 616,
        name: 'Apartment Renters',
        hidden: false,
        persona_type: 'lifestage',
    },
    701: {
        _id: 701,
        name: 'Apartment Hunters',
        hidden: false,
        persona_type: 'intent',
    },
    702: {
        _id: 702,
        name: 'Boat Owners',
        hidden: false,
        persona_type: 'interest',
    },
    703: {
        _id: 703,
        name: 'New Boat Owners',
        hidden: true,
        skip_calc: true,
        persona_type: 'lifestage',
    },
    704: {
        _id: 704,
        name: 'Boat Shoppers',
        hidden: true,
        persona_type: 'intent',
    },
    706: {
        _id: 706,
        name: 'College Kids',
        hidden: false,
        persona_type: 'lifestage',
    },
    707: {
        _id: 707,
        name: 'Country Club Members',
        hidden: true,
        persona_type: 'lifestage',
    },
    708: {
        _id: 708,
        name: 'Expectant Parents',
        hidden: false,
        persona_type: 'lifestage',
    },
    709: {
        _id: 709,
        name: 'Dads To Be',
        hidden: false,
        persona_type: 'lifestage',
    },
    710: {
        _id: 710,
        name: 'Moms To Be',
        hidden: true,
        skip_calc: true,
        persona_type: 'lifestage',
    },
    711: {
        _id: 711,
        name: 'Family Caretakers',
        hidden: false,
        persona_type: 'lifestage',
    },
    712: {
        _id: 712,
        name: 'Home Owners',
        hidden: false,
        persona_type: 'lifestage',
    },
    713: {
        _id: 713,
        name: 'New Home Owners',
        hidden: true,
        skip_calc: true,
        persona_type: 'lifestage',
    },
    714: {
        _id: 714,
        name: 'Job Seekers',
        hidden: false,
        persona_type: 'lifestage',
    },
    715: {
        _id: 715,
        name: 'Just Moved',
        hidden: true,
        skip_calc: true,
        persona_type: 'lifestage',
    },
    717: {
        _id: 717,
        name: 'Luxury Living',
        hidden: false,
        persona_type: 'lifestage',
    },
    720: {
        _id: 720,
        name: 'New Job Holders',
        hidden: true,
        skip_calc: true,
        persona_type: 'lifestage',
    },
    721: {
        _id: 721,
        name: 'Newlyweds',
        hidden: true,
        skip_calc: true,
        persona_type: 'lifestage',
    },
    725: {
        _id: 725,
        name: 'New Parents',
        hidden: false,
        persona_type: 'lifestage',
    },
    726: {
        _id: 726,
        name: 'New Dads',
        hidden: false,
        persona_type: 'lifestage',
    },
    734: {
        _id: 734,
        name: 'Cat Owners',
        hidden: false,
        persona_type: 'lifestage',
    },
    735: {
        _id: 735,
        name: 'Dog Owners',
        hidden: false,
        persona_type: 'lifestage',
    },
    736: {
        _id: 736,
        name: 'Preparing to Move',
        hidden: true,
        persona_type: 'lifestage',
    },
    738: {
        _id: 738,
        name: 'Recently Engaged',
        hidden: false,
        persona_type: 'lifestage',
    },
    739: {
        _id: 739,
        name: 'Brides To Be',
        hidden: false,
        persona_type: 'lifestage',
    },
    740: {
        _id: 740,
        name: 'Grooms To Be',
        hidden: false,
        persona_type: 'lifestage',
    },
    742: {
        _id: 742,
        name: 'Retirement Planners',
        hidden: false,
        persona_type: 'lifestage',
    },
    744: {
        _id: 744,
        name: 'Vehicle Owners',
        hidden: false,
        persona_type: 'interest',
    },
    745: {
        _id: 745,
        name: 'New Vehicle Owners',
        hidden: true,
        skip_calc: true,
        persona_type: 'lifestage',
    },
    746: {
        _id: 746,
        name: 'DIY Auto',
        hidden: false,
        persona_type: 'interest',
    },
    747: {
        _id: 747,
        name: 'Auto Insurance Owners',
        hidden: true,
        skip_calc: true,
        persona_type: 'interest',
    },
    748: {
        _id: 748,
        name: 'Influencers',
        hidden: false,
        persona_type: 'interest',
    },
    749: {
        _id: 749,
        name: 'Bloggers',
        hidden: false,
        persona_type: 'interest',
    },
    750: {
        _id: 750,
        name: 'Writers',
        hidden: false,
        persona_type: 'interest',
    },
    751: {
        _id: 751,
        name: 'Arts and Crafts Lovers',
        hidden: false,
        persona_type: 'interest',
    },
    753: {
        _id: 753,
        name: 'Comedy Connoisseurs',
        hidden: false,
        persona_type: 'interest',
    },
    757: {
        _id: 757,
        name: 'Theater Patrons',
        hidden: false,
        persona_type: 'interest',
    },
    758: {
        _id: 758,
        name: 'Contest Seekers',
        hidden: false,
        persona_type: 'interest',
    },
    759: {
        _id: 759,
        name: 'Green Friendly',
        hidden: false,
        persona_type: 'interest',
    },
    760: {
        _id: 760,
        name: 'Wilderness Lovers',
        hidden: false,
        persona_type: 'interest',
    },
    761: {
        _id: 761,
        name: 'Mobile Banking Users',
        hidden: false,
        persona_type: 'interest',
    },
    762: {
        _id: 762,
        name: 'Insurance Owners',
        hidden: false,
        persona_type: 'interest',
    },
    763: {
        _id: 763,
        name: 'Active Traders',
        hidden: false,
        persona_type: 'interest',
    },
    764: {
        _id: 764,
        name: 'Casual Investors',
        hidden: false,
        persona_type: 'interest',
    },
    766: {
        _id: 766,
        name: 'Home Chefs',
        hidden: false,
        persona_type: 'interest',
    },
    767: {
        _id: 767,
        name: 'Restaurant Hoppers',
        hidden: false,
        persona_type: 'interest',
    },
    768: {
        _id: 768,
        name: 'Fast Food Patrons',
        hidden: false,
        persona_type: 'interest',
    },
    769: {
        _id: 769,
        name: 'Fine Dining Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    770: {
        _id: 770,
        name: 'Avid Hikers',
        hidden: false,
        persona_type: 'interest',
    },
    771: {
        _id: 771,
        name: 'Gardeners',
        hidden: false,
        persona_type: 'interest',
    },
    772: {
        _id: 772,
        name: 'Home Improvement Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    773: {
        _id: 773,
        name: 'Outdoor Sports Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    775: {
        _id: 775,
        name: 'Camping Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    776: {
        _id: 776,
        name: 'Extreme Sports Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    777: {
        _id: 777,
        name: 'Fishing Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    778: {
        _id: 778,
        name: 'Golfing Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    779: {
        _id: 779,
        name: 'Hunting Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    780: {
        _id: 780,
        name: 'Home Automation Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    781: {
        _id: 781,
        name: 'Home Entertainment Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    782: {
        _id: 782,
        name: 'Prepaid Phone Users',
        hidden: false,
        persona_type: 'interest',
    },
    783: {
        _id: 783,
        name: 'Wireless Plan App Owners',
        hidden: false,
        persona_type: 'interest',
    },
    784: {
        _id: 784,
        name: 'Commuters',
        hidden: false,
        persona_type: 'interest',
    },
    785: {
        _id: 785,
        name: 'Cruise Travelers',
        hidden: false,
        persona_type: 'interest',
    },
    787: {
        _id: 787,
        name: 'Road Trippers',
        hidden: false,
        persona_type: 'interest',
    },
    789: {
        _id: 789,
        name: 'Auto Insurance Shoppers',
        hidden: true,
        skip_calc: true,
        persona_type: 'intent',
    },
    790: {
        _id: 790,
        name: 'Pharmacy Patrons',
        hidden: false,
        persona_type: 'intent',
    },
    791: {
        _id: 791,
        name: 'Legal Counsel Seekers',
        hidden: true,
        persona_type: 'intent',
    },
    792: {
        _id: 792,
        name: 'Auction Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    794: {
        _id: 794,
        name: 'Department Store Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    795: {
        _id: 795,
        name: 'Gift Givers',
        hidden: false,
        persona_type: 'intent',
    },
    796: {
        _id: 796,
        name: 'Holiday Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    797: {
        _id: 797,
        name: 'Impulse Buyers',
        hidden: false,
        persona_type: 'intent',
    },
    798: {
        _id: 798,
        name: 'Upscale Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    799: {
        _id: 799,
        name: 'Young & Hip Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    800: {
        _id: 800,
        name: 'Ticket Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    801: {
        _id: 801,
        name: 'Jewelry Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    802: {
        _id: 802,
        name: 'Shoes Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    803: {
        _id: 803,
        name: 'Electronics Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    804: {
        _id: 804,
        name: 'Tech & Gadget Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    805: {
        _id: 805,
        name: 'Travel Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    806: {
        _id: 806,
        name: 'Cruise Shoppers',
        hidden: true,
        persona_type: 'intent',
    },
    807: {
        _id: 807,
        name: 'Flight Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    808: {
        _id: 808,
        name: 'Hotel Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    809: {
        _id: 809,
        name: 'Rental Car Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    810: {
        _id: 810,
        name: 'Vacation Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    819: {
        _id: 819,
        name: 'French Speakers',
        hidden: true,
        skip_calc: true,
        persona_type: 'language',
    },
    820: {
        _id: 820,
        name: 'German Speakers',
        hidden: true,
        skip_calc: true,
        persona_type: 'language',
    },
    821: {
        _id: 821,
        name: 'Italian Speakers',
        hidden: true,
        skip_calc: true,
        persona_type: 'language',
    },
    822: {
        _id: 822,
        name: 'Chinese Speakers',
        hidden: true,
        skip_calc: true,
        persona_type: 'language',
    },
    823: {
        _id: 823,
        name: 'Japanese Speakers',
        hidden: true,
        skip_calc: true,
        persona_type: 'language',
    },
    824: {
        _id: 824,
        name: 'Hockey Fans',
        hidden: false,
        persona_type: 'interest',
    },
    825: {
        _id: 825,
        name: 'Flower Shoppers',
        hidden: true,
        persona_type: 'intent',
    },
    826: {
        _id: 826,
        name: 'Hair & Makeup Mavens',
        hidden: false,
        persona_type: 'intent',
    },
    827: {
        _id: 827,
        name: 'Calorie Counters',
        hidden: false,
        persona_type: 'interest',
    },
    828: {
        _id: 828,
        name: 'Office Supply Shoppers',
        hidden: false,
        persona_type: 'intent',
    },
    829: {
        _id: 829,
        name: 'Business Directory Searchers',
        hidden: false,
        persona_type: 'intent',
    },
    837: {
        _id: 837,
        name: 'Ride Sharers',
        hidden: false,
        persona_type: 'interest',
    },
    838: {
        _id: 838,
        name: 'Auto Sharers',
        hidden: false,
        persona_type: 'interest',
    },
    839: {
        _id: 839,
        name: 'Room Sharers',
        hidden: false,
        persona_type: 'interest',
    },
    840: {
        _id: 840,
        name: 'Fantasy Sports Players',
        hidden: false,
        persona_type: 'interest',
    },
    841: {
        _id: 841,
        name: 'Free Content Streamers',
        hidden: false,
        persona_type: 'interest',
    },
    842: {
        _id: 842,
        name: 'On Demand Movie Streamers',
        hidden: false,
        persona_type: 'interest',
    },
    843: {
        _id: 843,
        name: 'Over the Top Device Owners',
        hidden: false,
        persona_type: 'interest',
    },
    844: {
        _id: 844,
        name: 'Smart TV Owners',
        hidden: false,
        persona_type: 'interest',
    },
    845: {
        _id: 845,
        name: 'Subscription Content Streamers',
        hidden: false,
        persona_type: 'interest',
    },
    846: {
        _id: 846,
        name: 'Basic TV Streamers',
        hidden: false,
        persona_type: 'interest',
    },
    847: {
        _id: 847,
        name: 'Premium TV Streamers',
        hidden: false,
        persona_type: 'interest',
    },
    848: {
        _id: 848,
        name: 'Service Provider Streamers',
        hidden: false,
        persona_type: 'interest',
    },
    849: {
        _id: 849,
        name: 'Video Streamers',
        hidden: false,
        persona_type: 'interest',
    },
    850: {
        _id: 850,
        name: 'TV Cord Cutters',
        hidden: false,
        persona_type: 'interest',
    },
    851: {
        _id: 851,
        name: 'TV Subscribers',
        hidden: false,
        persona_type: 'interest',
    },
    852: {
        _id: 852,
        name: 'Sharing Economy Participants',
        hidden: false,
        persona_type: 'interest',
    },
    853: {
        _id: 853,
        name: 'Coffee Connoisseurs',
        hidden: false,
        persona_type: 'interest',
    },
    854: {
        _id: 854,
        name: 'eSports Fans',
        hidden: false,
        persona_type: 'interest',
    },
    855: {
        _id: 855,
        name: 'Concertgoers',
        hidden: false,
        persona_type: 'interest',
    },
    856: {
        _id: 856,
        name: 'Music Discovery Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    857: {
        _id: 857,
        name: 'Music Sharers',
        hidden: false,
        persona_type: 'interest',
    },
    858: {
        _id: 858,
        name: 'Music Streamers',
        hidden: false,
        persona_type: 'interest',
    },
    859: {
        _id: 859,
        name: 'Photo Editors',
        hidden: false,
        persona_type: 'interest',
    },
    860: {
        _id: 860,
        name: 'Photo Printing Enthusiasts',
        hidden: false,
        persona_type: 'interest',
    },
    861: {
        _id: 861,
        name: 'Photo Sharers',
        hidden: false,
        persona_type: 'interest',
    },
    862: {
        _id: 862,
        name: 'Photographers',
        hidden: false,
        persona_type: 'interest',
    },
    863: {
        _id: 863,
        name: 'Avid Surfers',
        hidden: false,
        persona_type: 'interest',
    },
    864: {
        _id: 864,
        name: 'On-Demand Economy Participants',
        hidden: false,
        persona_type: 'interest',
    },
    865: {
        _id: 865,
        name: 'On-Demand Food Delivery',
        hidden: false,
        persona_type: 'interest',
    },
    866: {
        _id: 866,
        name: 'On-Demand Learning',
        hidden: false,
        persona_type: 'interest',
    },
    867: {
        _id: 867,
        name: 'On-Demand Parking',
        hidden: false,
        persona_type: 'interest',
    },
    868: {
        _id: 868,
        name: 'On-Demand Shopping',
        hidden: false,
        persona_type: 'interest',
    },
    869: {
        _id: 869,
        name: 'On-Demand Transportation',
        hidden: false,
        persona_type: 'interest',
    },
    871: {
        _id: 871,
        name: 'Political Views - Democrat',
        hidden: true,
        skip_calc: true,
        persona_type: 'interest',
    },
    872: {
        _id: 872,
        name: 'Political Views - Republican',
        hidden: true,
        skip_calc: true,
        persona_type: 'interest',
    },
    874: {
        _id: 874,
        name: 'Australian Football Fans',
        hidden: false,
        persona_type: 'interest',
    },
    875: {
        _id: 875,
        name: 'Cricket Fans',
        hidden: false,
        persona_type: 'interest',
    },
    876: {
        _id: 876,
        name: 'Rugby Fans',
        hidden: true,
        persona_type: 'interest',
    },
    877: {
        _id: 877,
        name: 'Soccer Fans',
        hidden: false,
        persona_type: 'interest',
    },
    878: {
        _id: 878,
        name: 'UFC Fans',
        hidden: false,
        persona_type: 'interest',
    },
    879: {
        _id: 879,
        name: 'Educators',
        hidden: false,
        persona_type: 'lifestage',
    },
    880: {
        _id: 880,
        name: 'Online Education Students',
        hidden: false,
        persona_type: 'lifestage',
    },
    881: {
        _id: 881,
        name: 'Flash Sales Consumers',
        hidden: false,
        persona_type: 'intent',
    },
    882: {
        _id: 882,
        name: 'Daily Deals Consumers ',
        hidden: false,
        persona_type: 'intent',
    },
    883: {
        _id: 883,
        name: 'Mobile Wallet Users',
        hidden: false,
        persona_type: 'interest',
    },
    884: {
        _id: 884,
        name: 'On-Demand Lodging',
        hidden: false,
        persona_type: 'interest',
    },
    885: {
        _id: 885,
        name: 'Tennis Fans',
        hidden: true,
        skip_calc: true,
        persona_type: 'interest',
    },
    886: {
        _id: 886,
        name: 'WiFi Finder Users',
        hidden: false,
        persona_type: 'interest',
    },
    887: {
        _id: 887,
        name: 'New Health & Fitness Buffs',
        hidden: false,
        persona_type: 'intent',
    },
    888: {
        _id: 888,
        name: 'Moms',
        hidden: false,
        persona_type: 'lifestage',
    },
    889: {
        _id: 889,
        name: 'Dads',
        hidden: false,
        persona_type: 'lifestage',
    },
    890: {
        _id: 890,
        name: 'Millennials',
        hidden: false,
        persona_type: 'lifestage',
    },
    891: {
        _id: 891,
        name: 'Baby Boomers',
        hidden: false,
        persona_type: 'lifestage',
    },
    892: {
        _id: 892,
        name: 'Generation X',
        hidden: false,
        persona_type: 'lifestage',
    },
    893: {
        _id: 893,
        name: 'This persona is deprecated',
        hidden: true,
        persona_type: 'lifestage',
    },
    894: {
        _id: 894,
        name: 'Heavy Video Streamers',
        hidden: false,
        persona_type: 'interest',
    },
    895: {
        _id: 895,
        name: 'Heavy Music Streamers',
        hidden: false,
        persona_type: 'interest',
    },
    896: {
        _id: 896,
        name: 'Committed TV Cord Cutters',
        hidden: false,
        persona_type: 'interest',
    },
    897: {
        _id: 897,
        name: 'Casino Gamers',
        hidden: false,
        persona_type: 'interest',
    },
    898: {
        _id: 898,
        name: 'Prediction Markets',
        hidden: false,
        persona_type: 'interest',
    },
    900: {
        _id: 900,
        name: 'Device Carrier Verizon',
        hidden: false,
        persona_type: 'attribute',
    },
    901: {
        _id: 901,
        name: 'Device Carrier AT&T',
        hidden: false,
        persona_type: 'attribute',
    },
    902: {
        _id: 902,
        name: 'Device Carrier T-Mobile',
        hidden: false,
        persona_type: 'attribute',
    },
    903: {
        _id: 903,
        name: 'Device Carrier Sprint',
        hidden: false,
        persona_type: 'attribute',
    },
    910: {
        _id: 910,
        name: 'Device Carrier Rogers',
        hidden: false,
        persona_type: 'attribute',
    },
    911: {
        _id: 911,
        name: 'Device Carrier Telus',
        hidden: false,
        persona_type: 'attribute',
    },
    912: {
        _id: 912,
        name: 'Device Carrier Bell Mobility',
        hidden: false,
        persona_type: 'attribute',
    },
    920: {
        _id: 920,
        name: 'Device Carrier Telstra',
        hidden: false,
        persona_type: 'attribute',
    },
    921: {
        _id: 921,
        name: 'Device Carrier Vodafone',
        hidden: false,
        persona_type: 'attribute',
    },
    922: {
        _id: 922,
        name: 'Device Carrier Singtel Optus',
        hidden: false,
        persona_type: 'attribute',
    },
    1000: {
        _id: 1000,
        name: 'Device Manufacturer Apple',
        hidden: false,
        persona_type: 'attribute',
    },
    1001: {
        _id: 1001,
        name: 'Device Manufacturer Samsung',
        hidden: false,
        persona_type: 'attribute',
    },
    1002: {
        _id: 1002,
        name: 'Device Manufacturer LG',
        hidden: false,
        persona_type: 'attribute',
    },
    1003: {
        _id: 1003,
        name: 'Device Manufacturer ZTE',
        hidden: false,
        persona_type: 'attribute',
    },
    1004: {
        _id: 1004,
        name: 'Device Manufacturer Motorola',
        hidden: false,
        persona_type: 'attribute',
    },
    1005: {
        _id: 1005,
        name: 'Device Manufacturer Alcatel',
        hidden: false,
        persona_type: 'attribute',
    },
    1006: {
        _id: 1006,
        name: 'Device Manufacturer HTC',
        hidden: false,
        persona_type: 'attribute',
    },
    1007: {
        _id: 1007,
        name: 'Device Manufacturer Google',
        hidden: false,
        persona_type: 'attribute',
    },
    1020: {
        _id: 1020,
        name: 'Device Age < 1 Year',
        hidden: false,
        persona_type: 'attribute',
    },
    1021: {
        _id: 1021,
        name: 'Device Age 1 - 2 Years',
        hidden: false,
        persona_type: 'attribute',
    },
    1022: {
        _id: 1022,
        name: 'Device Age > 2 Years',
        hidden: true,
        skip_calc: true,
        persona_type: 'attribute',
    },
    1023: {
        _id: 1023,
        name: 'Device Age 2 - 3 Years',
        hidden: false,
        persona_type: 'attribute',
    },
    1024: {
        _id: 1024,
        name: 'Device Age 3 - 4 Years',
        hidden: false,
        persona_type: 'attribute',
    },
    1025: {
        _id: 1025,
        name: 'Device Age 4 - 5 Years',
        hidden: false,
        persona_type: 'attribute',
    },
    1026: {
        _id: 1026,
        name: 'Device Age > 5 Years',
        hidden: false,
        persona_type: 'attribute',
    },
    1030: {
        _id: 1030,
        name: 'Device Performance Low',
        hidden: false,
        persona_type: 'attribute',
    },
    1031: {
        _id: 1031,
        name: 'Device Performance Medium',
        hidden: false,
        persona_type: 'attribute',
    },
    1032: {
        _id: 1032,
        name: 'Device Performance High',
        hidden: false,
        persona_type: 'attribute',
    },
};

// 60000 range of personas is reserved for MaidBiweekly segments being passed to MediaMath

publicConstants.TaxonomyHierarchy = {
    70000: {
        71000: {
            71001: [304, 704],
            71002: [800],
            71003: [602, 798, 799, 801, 802, 826],
            71004: [790],
            71005: [791],
            71006: [103, 701],
            71007: [303, 305, 792, 794, 795, 796, 797, 825, 828, 829, 881, 882],
            71008: [803, 804],
            71009: [805, 806, 807, 808, 809, 810],
            71010: [887],
        },
        72000: {
            72001: [501, 505, 506, 610, 751, 753, 757, 855, 856, 857, 858, 859, 860, 861, 862, 895],
            72002: [601, 702, 744, 746],
            72003: [612, 748, 749, 750],
            72004: [759, 760],
            72005: [102, 302, 761, 762, 763, 764, 883, 898],
            72006: [603, 766, 767, 768, 769, 853],
            72007: [502, 504, 508, 509, 514, 515, 758, 854, 897],
            72008: [402, 403, 404, 405, 406, 770, 827, 863],
            72009: [605, 771, 772],
            72010: [512, 513],
            72011: [
                401, 407, 408, 409, 410, 411, 412, 773, 775, 776, 777, 778, 779, 824, 840, 874, 875, 876, 877, 878, 885,
            ],
            72012: [614, 780, 781, 886],
            72013: [782, 783],
            72014: [201, 202, 784, 785, 787],
            72015: [837, 838, 839, 852],
            72016: [841, 842, 843, 844, 845, 846, 847, 848, 849, 850, 851, 894, 896],
            72017: [864, 865, 866, 867, 868, 869, 884],
            72018: [871, 872],
        },
        73000: {
            73002: [101, 104, 714],
            73003: [706, 879, 880],
            73004: [607, 608, 609, 708, 709, 710, 711, 725, 726, 734, 735, 888, 889],
            73005: [604, 742],
            73006: [707, 717],
            73007: [611, 738, 739, 740],
            73008: [616, 712, 736],
            73009: [890, 891, 892],
        },
        74000: {
            74001: [50060, 50061],
            74002: [613],
            74003: [50050, 50051, 50052, 50053, 50054, 50055],
            74004: [50040, 50041, 50042, 50043, 50044, 50045],
        },
    },
    75000: {
        children: [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 29],
        75001: [60, 61, 62, 63, 64, 65, 66, 67, 68, 70, 71, 72, 73, 74, 75, 76, 77, 78],
    },
    //"76000": {
    //"76001": [50001, 50002, 50003, 50004, 50005,50040,50041,50042,50043,50044,50045],
    //"76002": [50021, 50022, 50060, 50061],
    //"76003": [50030, 50031, 50032, 50033, 50034, 50035, 50050, 50051, 50052, 50053, 50054, 50055]
    //},
    77000: {
        77010: [
            'A198465',
            'A8070',
            'A12088',
            'A6666',
            'A12354',
            'A98821',
            'A8265',
            'A6893',
            'A18180',
            'A8795',
            'A7172',
            'A18419',
        ],
        77011: ['A12186', 'A12447', 'A8369', 'A98818', 'A8655', 'A7136', 'A8784', 'A4218932'],
        77012: [
            'A19842',
            'A2905437',
            'A10655',
            'A14014',
            'A7003',
            'A34910',
            'A96414',
            'A20033',
            'A18265',
            'A99065',
            'A1984888',
            'A21831',
            'A1471871',
            'A13378',
            'A2027360',
            'A2291014',
            'A19971',
            'A25868',
        ],
        77013: [
            'A7201',
            'A6802',
            'A6602',
            'A6958',
            'A6887',
            'A198610',
            'A6970',
            'A13610',
            'A4464435',
            'A1474709',
            'A2468379',
            'A21872',
        ],
        77014: [
            'A8466',
            'A6816',
            'A6962',
            'A10794',
            'A19379',
            'A6874',
            'A12512',
            'A6988',
            'A98822',
            'A13666',
            'A14051',
            'A9518',
            'A8290',
            'A8786',
            'A10860',
            'A8628',
            'A1469851',
            'A99272',
            'A198772',
        ],
        77015: [
            'A98830',
            'A6589',
            'A198802',
            'A7151',
            'A98805',
            'A2027014',
            'A7142',
            'A8276',
            'A11327',
            'A98838',
            'A25001',
            'A98807',
            'A9625',
            'A8792',
            'A8958',
            'A11227',
            'A8835',
            'A17159',
            'A1476894',
            'A15294',
            'A1893200',
            'A23267',
            'A23822',
            'A8450',
        ],
        77016: [
            'A98836',
            'A33811',
            'A11009',
            'A98832',
            'A7188',
            'A6668',
            'A10967',
            'A2484694',
            'A8757',
            'A8446',
            'A6980',
            'A1470162',
        ],
        77017: [
            'A18415',
            'A20224',
            'A22287',
            'A20213',
            'A20019',
            'A43442',
            'A24390',
            'A10812',
            'A11954',
            'A31459',
            'A14542',
            'A2141918',
        ],
        77018: [
            'A15325',
            'A6983',
            'A6595',
            'A13861',
            'A2029230',
            'A11233',
            'A17152',
            'A17138',
            'A6875',
            'A198821',
            'A118879',
            'A4494124',
            'A552278',
            'A6670',
            'A19961',
            'A6967',
            'A99044',
            'A7320',
            'A6661',
        ],
        77019: [
            'A98814',
            'A6877',
            'A10199',
            'A498074',
            'A1168125',
            'A1259317',
            'A99045',
            'A2319485',
            'A2027701',
            'A18133',
        ],
        77020: [
            'A8434',
            'A11303',
            'A14037',
            'A17232',
            'A198510',
            'A8982',
            'A98859',
            'A19844',
            'A99104',
            'A19814',
            'A12349',
            'A6608',
            'A12201',
            'A9017',
            'A18378',
            'A98820',
            'A11232',
        ],
        77021: [
            'A17210',
            'A99573',
            'A11026',
            'A15601',
            'A6822',
            'A10991',
            'A10820',
            'A198775',
            'A15697',
            'A17192',
            'A509631',
            'A2484768',
            'A8650',
            'A7138',
            'A2027389',
        ],
        77022: [
            'A98793',
            'A8438',
            'A6991',
            'A7318',
            'A6929',
            'A6652',
            'A6659',
            'A6778',
            'A2533539',
            'A12707',
            'A7155',
            'A7137',
        ],
        77023: [
            'A99051',
            'A99996',
            'A12140',
            'A6488',
            'A6636',
            'A98804',
            'A12696',
            'A6707',
            'A6976',
            'A6797',
            'A8079',
            'A98808',
            'A6598',
            'A7165',
            'A8787',
            'A6604',
            'A6625',
            'A98825',
            'A98817',
            'A1471118',
        ],
        77024: [
            'A34252',
            'A198579',
            'A19385',
            'A8432',
            'A198679',
            'A23235',
            'A98866',
            'A12244',
            'A8823',
            'A7124',
            'A7017',
            'A14086',
            'A10624',
            'A10636',
            'A12347',
            'A1020126',
            'A11035',
            'A14189',
            'A6268',
            'A1471615',
        ],
        77025: [
            'A98823',
            'A6660',
            'A12357',
            'A11008',
            'A11331',
            'A8250',
            'A13656',
            'A11340',
            'A98810',
            'A198682',
            'A10458',
            'A6706',
            'A6845',
            'A10459',
            'A8950',
            'A13707',
            'A15704',
            'A11049',
        ],
        77026: [
            'A6975',
            'A23241',
            'A6946',
            'A13851',
            'A6956',
            'A6837',
            'A6460',
            'A11350',
            'A6638',
            'A1469941',
            'A1472248',
            'A12684',
        ],
        77027: [
            'A3535239',
            'A8248',
            'A98800',
            'A198663',
            'A19424',
            'A99064',
            'A7019',
            'A19370',
            'A6637',
            'A19773',
            'A43914',
            'A98783',
            'A12232',
            'A19490',
            'A15709',
        ],
        77028: {
            77060: [
                'A1471549',
                'A1471512',
                'A3756134',
                'A3093882',
                'A3113321',
                'A3555531',
                'A20681',
                'A8620',
                'A3408589',
                'A2016328',
                'A2067671',
                'A99266',
            ],
            77061: [
                'A31325',
                'A3556655',
                'A98839',
                'A72071',
                'A3712003',
                'A2364359',
                'A98858',
                'A2876348',
                'A3284494',
                'A2431542',
                'A136739',
            ],
            77062: [
                'A3794089',
                'A2036973',
                'A480930',
                'A2055752',
                'A11231',
                'A8286',
                'A13994',
                'A99309',
                'A8962',
                'A2156000',
                'A2596625',
                'A8829',
                'A14262',
                'A98863',
                'A12073',
                'A2212243',
                'A3285916',
            ],
            77063: [
                'A1470348',
                'A727638',
                'A2315399',
                'A15686',
                'A24762',
                'A17169',
                'A13680',
                'A24198',
                'A106948',
                'A2375346',
                'A21869',
                'A22334',
                'A23720',
                'A22663',
                'A3218229',
            ],
            77064: [
                'A7605',
                'A14007',
                'A144733',
                'A7190',
                'A15875',
                'A50626',
                'A12855',
                'A2090547',
                'A20917',
                'A99584',
                'A3093500',
                'A25694',
            ],
            77065: [
                'A17211',
                'A17162',
                'A98865',
                'A17209',
                'A31934',
                'A100563',
                'A20879',
                'A19564',
                'A39037',
                'A20759',
                'A12342',
                'A100003',
                'A21167',
                'A20109',
                'A99042',
                'A3152001',
                'A2212013',
                'A2595350',
                'A1995989',
            ],
            77066: [
                'A2069891',
                'A74559',
                'A7006',
                'A204699',
                'A8274',
                'A11192',
                'A3265451',
                'A6624',
                'A2074067',
                'A12467',
                'A10591',
                'A12243',
                'A7593',
                'A19366',
                'A265022',
                'A2924701',
                'A2312739',
                'A12350',
                'A2612611',
                'A8640',
            ],
            77067: ['A52119', 'A2438821', 'A2463370', 'A267376', 'A20249', 'A19664'],
            77068: ['A2188678', 'A19956', 'A298510', 'A2366909'],
            77070: [
                'A50068',
                'A2424001',
                'A18888',
                'A2904072',
                'A13993',
                'A1847612',
                'A147752',
                'A13986',
                'A1977461',
                'A2561384',
                'A1591836',
                'A3048412',
                'A1984673',
                'A15862',
            ],
            77071: [
                'A433662',
                'A1897103',
                'A1878058',
                'A10833',
                'A3732174',
                'A2860504',
                'A8661',
                'A26964',
                'A2073960',
                'A2075892',
                'A2013539',
                'A2413083',
                'A6739',
            ],
            77072: [
                'A379577',
                'A3445771',
                'A6685',
                'A12165',
                'A20042',
                'A19363',
                'A19671',
                'A19808',
                'A12461',
                'A18158',
                'A3032225',
                'A3169453',
                'A99543',
                'A296405',
                'A2312438',
                'A2941901',
                'A2217979',
                'A20957',
                'A3325229',
            ],
            77073: [
                'A2046956',
                'A141392',
                'A19520',
                'A2878401',
                'A3799134',
                'A130155',
                'A2404805',
                'A8415',
                'A2349965',
                'A2402472',
                'A2441374',
                'A2905466',
            ],
            77074: [
                'A2641649',
                'A1860792',
                'A2027211',
                'A22906',
                'A20655',
                'A98873',
                'A23637',
                'A2442096',
                'A11238',
                'A2312364',
                'A2025008',
                'A2455496',
            ],
            77075: [
                'A17242',
                'A2293053',
                'A127131',
                'A42916',
                'A37780',
                'A1834977',
                'A3363066',
                'A99131',
                'A19845',
                'A40223',
                'A3322157',
                'A2390866',
            ],
            77076: [
                'A28427',
                'A2028852',
                'A96820',
                'A23741',
                'A18574',
                'A44170',
                'A2818348',
                'A6705',
                'A19881',
                'A3284791',
                'A17968',
                'A2027090',
            ],
            77077: [
                'A2612823',
                'A17218',
                'A99850',
                'A100297',
                'A2025200',
                'A2902897',
                'A12732',
                'A8078',
                'A2052595',
                'A12731',
                'A2963417',
                'A91320',
                'A100292',
                'A290471',
                'A2126507',
                'A2313014',
                'A2652616',
                'A2818421',
                'A12984',
            ],
            77078: [
                'A98837',
                'A9422',
                'A11046',
                'A41255',
                'A19852',
                'A98871',
                'A12742',
                'A6810',
                'A2282110',
                'A20779',
                'A9453',
                'A2435706',
                'A2641984',
                'A131',
                'A3326976',
            ],
        },
        77029: [
            'A2073935',
            'A7144',
            'A14171',
            'A6612',
            'A6794',
            'A8469',
            'A6613',
            'A98856',
            'A198507',
            'A8420',
            'A98811',
            'A7157',
            'A8826',
            'A14221',
            'A8275',
            'A13681',
            'A19297',
            'A7148',
            'A12358',
            'A6955',
        ],
    },
    78000: {
        78100: [900, 901, 902, 903, 910, 911, 912, 920, 921, 922],
        78200: [1000, 1001, 1002, 1003, 1004, 1005, 1006, 1007],
        78300: [1020, 1021, 1023, 1024, 1025, 1026],
        78400: [1030, 1031, 1032],
    },
};

publicConstants.PlatformSegments = [
    { name: 'iOS', value: '1' },
    { name: 'Android', value: '2' },
];

publicConstants.Platform = {};
publicConstants.Platform.Unknown = 0;
publicConstants.Platform.iOS = 1;
publicConstants.Platform.Android = 2;

publicConstants.Store = {};
publicConstants.Store.iTunes = 1;
publicConstants.Store.Play = 2;

publicConstants.DataPartnerReportCategories = {
    direct: 'Direct Partner',
    liveramp: 'LiveRamp',
    dds: 'LiveRamp DDS',
};

// Controls the stages a Partner goes through in our system. Up to the
// individual subsystems to interpret but some examples listed for each
// state below.
// Status should be close to https://pushspring.atlassian.net/wiki/spaces/PROD/pages/735936513/Marketplace+Partners
const DataPartnerStatus = {
    Draft: 1, // Starting to collect data, preparing relationships and meta-data, testing before publishing, etc.
    Active: 2, // Visible in the frontend, ready for sale, etc.
    Inactive: 3, // Not visible in the frontend, offsale, warnings when editing existing audiences, etc.
    Deleted: 4, // Do not collect or process data in the backend
};
publicConstants.DataPartnerStatus = DataPartnerStatus;

publicConstants.DataPartners = [
    {
        id: 'PushSpring',
        name: 'T-Mobile Mobility Data',
        alternativeNames: ['PushSpring', 'Magenta Marketing Platform', 'Magenta Advertising Platform'],
        status: DataPartnerStatus.Active,
        orgId: 0,
        reportCategory: 'PushSpring',
    },
    {
        id: 'Comscore',
        name: 'comScore',
        status: DataPartnerStatus.Deleted,
        orgId: 336,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'Cuebiq',
        name: 'Cuebiq',
        status: DataPartnerStatus.Deleted,
        orgId: 506,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'Pinsight',
        name: 'Pinsight',
        status: DataPartnerStatus.Deleted,
        orgId: 726,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'Placecast',
        name: 'Placecast',
        status: DataPartnerStatus.Deleted,
        orgId: 240,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'SMS',
        name: 'SMS',
        status: DataPartnerStatus.Active,
        orgId: 922,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'Bombora',
        name: 'Bombora',
        status: DataPartnerStatus.Active,
        orgId: 923,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'AmeribaseDigital',
        name: 'Ameribase Digital',
        status: DataPartnerStatus.Active,
        orgId: 924,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'Stirista',
        name: 'Stirista',
        status: DataPartnerStatus.Active,
        orgId: 925,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'V12',
        name: 'V12',
        status: DataPartnerStatus.Active,
        orgId: 949,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'PlaceIQ',
        name: 'PlaceIQ',
        status: DataPartnerStatus.Deleted,
        orgId: 632,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'Scanbuy',
        name: 'Scanbuy',
        status: DataPartnerStatus.Deleted,
        orgId: 735,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'Gravy',
        name: 'Gravy',
        status: DataPartnerStatus.Deleted,
        orgId: 952,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'test',
        name: 'Test',
        status: DataPartnerStatus.Deleted,
        orgId: 69,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'tivo',
        name: 'TiVo',
        status: DataPartnerStatus.Deleted,
        orgId: 1037,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'iri',
        name: 'IRI',
        status: DataPartnerStatus.Active,
        orgId: 1048,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'oneeightybytwo',
        name: '180byTwo',
        status: DataPartnerStatus.Active,
        orgId: 1921,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'Clickagy',
        name: 'Clickagy',
        status: DataPartnerStatus.Active,
        orgId: 1047,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'Alliant',
        name: 'Alliant',
        status: DataPartnerStatus.Active,
        orgId: 1068,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'Reveal',
        name: 'Reveal',
        status: DataPartnerStatus.Deleted,
        orgId: 1065,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'Epsilon',
        name: 'Epsilon',
        status: DataPartnerStatus.Active,
        orgId: 1082,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'ASLMarketing',
        name: 'ASL Marketing',
        status: DataPartnerStatus.Deleted,
        orgId: 1113,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'ShareThis',
        name: 'ShareThis',
        status: DataPartnerStatus.Active,
        orgId: 1112,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'NinthDecimal',
        name: 'NinthDecimal',
        status: DataPartnerStatus.Deleted,
        orgId: 1114,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'AnalyticsIQ',
        name: 'AnalyticsIQ',
        status: DataPartnerStatus.Active,
        orgId: 1145,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'Locally',
        name: 'LOCALLY',
        status: DataPartnerStatus.Deleted,
        orgId: 1151,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'AffinityAnswers',
        name: 'Affinity Answers',
        status: DataPartnerStatus.Active,
        orgId: 1188,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'AffinitySolutions',
        name: 'Affinity Solutions',
        status: DataPartnerStatus.Active,
        orgId: 1189,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'MeritDirect',
        name: 'MeritDirect',
        status: DataPartnerStatus.Deleted,
        orgId: 1224,
        // This is a DDS integration
        liverampdds: true,
        reportCategory: publicConstants.DataPartnerReportCategories.dds,
    },
    {
        id: 'StatSocial',
        name: 'StatSocial',
        status: DataPartnerStatus.Deleted,
        orgId: 1235,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'Skyhook',
        name: 'Skyhook',
        status: DataPartnerStatus.Deleted,
        orgId: 1237,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'Audigent',
        name: 'Audigent',
        status: DataPartnerStatus.Inactive,
        orgId: 1236,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'CrossPixel',
        name: 'Cross Pixel',
        status: DataPartnerStatus.Active,
        orgId: 1241,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'PeerLogix',
        name: 'PeerLogix',
        status: DataPartnerStatus.Deleted,
        orgId: 1255,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'Webbula',
        name: 'Webbula',
        status: DataPartnerStatus.Active,
        orgId: 1264,
        // This is a DDS integration
        liverampdds: true,
        reportCategory: publicConstants.DataPartnerReportCategories.dds,
    },
    {
        id: 'Claritas',
        name: 'Claritas',
        status: DataPartnerStatus.Active,
        orgId: 1268,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'thirtythreeacross',
        name: '33Across',
        status: DataPartnerStatus.Active,
        orgId: 1269,
        // This is a DDS integration
        liverampdds: true,
        reportCategory: publicConstants.DataPartnerReportCategories.dds,
    },
    {
        id: 'dishtv',
        name: 'Dish TV',
        status: DataPartnerStatus.Draft,
        orgId: 1281,
        // This is a DDS integration
        liverampdds: true,
        reportCategory: publicConstants.DataPartnerReportCategories.dds,
    },
    {
        id: 'insticator',
        name: 'Insticator',
        status: DataPartnerStatus.Deleted,
        orgId: 1347,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'alc',
        name: 'Adstra',
        alternativeNames: ['Adstra', 'ALC'], // The ALC data partner maps to the Adstra Datasource so I added both to the alternative names
        status: DataPartnerStatus.Active,
        orgId: 1373,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'xmode',
        name: 'X-Mode Social, Inc.',
        status: DataPartnerStatus.Deleted,
        orgId: 729,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'bridge',
        name: 'Bridge',
        status: DataPartnerStatus.Inactive,
        orgId: 1390,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'dstillery',
        name: 'Dstillery',
        status: DataPartnerStatus.Active,
        orgId: 1399,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'oneeightybytwodirect',
        name: '180byTwo',
        status: DataPartnerStatus.Deleted,
        orgId: 1405,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'wiland',
        name: 'Wiland',
        status: DataPartnerStatus.Active,
        orgId: 1440,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'killi',
        name: 'Reklaim',
        alternativeNames: ['Killi', 'Reklaim'],
        status: DataPartnerStatus.Inactive,
        orgId: 1476,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'equifax',
        name: 'Equifax',
        status: DataPartnerStatus.Active,
        orgId: 1475,
        // This is a DDS integration
        liverampdds: true,
        reportCategory: publicConstants.DataPartnerReportCategories.dds,
    },
    {
        id: 'dataaxle',
        name: 'Data Axle',
        alternativeNames: ['Infogroup'], // Original name was Infogroup
        status: DataPartnerStatus.Active,
        orgId: 1488,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'fyllo',
        name: 'Fyllo',
        status: DataPartnerStatus.Active,
        orgId: 1311,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'tmobiledataengineering',
        name: 'T-Mobile Data Engineering',
        status: DataPartnerStatus.Inactive,
        orgId: 1558,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'catalina',
        name: 'Catalina',
        status: DataPartnerStatus.Deleted,
        orgId: 1513,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'foursquare',
        name: 'Foursquare',
        status: DataPartnerStatus.Active,
        orgId: 1588,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'inmarket',
        name: 'InMarket',
        status: DataPartnerStatus.Deleted,
        orgId: 1600,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'amerilink',
        name: 'AmeriLink',
        status: DataPartnerStatus.Deleted,
        orgId: 1589,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'tivobdex',
        name: 'TiVo/BDEX',
        status: DataPartnerStatus.Active,
        orgId: 1601,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'placeiqdirect',
        name: 'PlaceIQ',
        status: DataPartnerStatus.Active,
        orgId: 1591,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'startio',
        name: 'Start.io',
        status: DataPartnerStatus.Active,
        orgId: 1696,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'analyticsiqdirect',
        name: 'AnalyticsIQ',
        status: DataPartnerStatus.Deleted,
        orgId: 1741,
        liveramp: false,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'ihsmarkitpolk',
        name: 'Polk Audiences by S&P Global Mobility',
        status: DataPartnerStatus.Active,
        orgId: 1761,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'comscore',
        name: 'Comscore',
        status: DataPartnerStatus.Deleted,
        orgId: 1841,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'cis',
        name: 'CIS',
        status: DataPartnerStatus.Deleted,
        orgId: 1842,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'homedata',
        name: 'Homedata',
        status: DataPartnerStatus.Deleted,
        orgId: 1843,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'sambatv',
        name: 'Samba TV',
        status: DataPartnerStatus.Deleted,
        orgId: 1880,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'loopme',
        name: 'Loopme',
        status: DataPartnerStatus.Active,
        orgId: 1881,
        liveramp: true,
        reportCategory: publicConstants.DataPartnerReportCategories.liveramp,
    },
    {
        id: 'deepsync',
        name: 'Deep Sync',
        status: DataPartnerStatus.Active,
        orgId: 1889,
        liverampdds: true,
        reportCategory: publicConstants.DataPartnerReportCategories.dds,
    },
    {
        id: 'sliide',
        name: 'Sliide',
        status: DataPartnerStatus.Draft,
        orgId: 1974,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },
    {
        id: 'unity',
        name: 'Unity',
        status: DataPartnerStatus.Draft,
        orgId: 763,
        reportCategory: publicConstants.DataPartnerReportCategories.direct,
    },

    // Add a mapping to marketplace_utils.SegmentContributingPartnerToDatasourceMapping when
    // you add one here
];

// Build out several legacy projections
publicConstants.SegmentContributingPartners = {};
publicConstants.OrgToSegmentContributingPartnerMapping = {};
publicConstants.DataPartners.forEach((partner) => {
    // Put in both id and name in case lookup isn't using right case
    publicConstants.SegmentContributingPartners[partner.id] = partner;
    if (partner.orgId !== undefined) {
        publicConstants.OrgToSegmentContributingPartnerMapping[partner.orgId] = partner;
    }
});

// Valid countries for segment builder queries
publicConstants.AllowedCountries = ['US', 'AU', 'CA'];

publicConstants.AllowedSegmentAttributes = [
    {
        name: 'App Engagement',
        // keep id === marketplaceConstants.DataTypeIds.AppEngagementApps,
        // warehouse_segmetns.appgraph_plus and TransmissionRestrictionService.getRestrictions both
        // use that constant to test for appgraph_plus flags
        id: 'appengagementapps',
        type: 'partner_data',
        field: 'attribute_id',
        tag: 'AppGraph+',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'Engagement Personas',
        // keep id === marketplaceConstants.DataTypeIds.AppEngagementPersonas,
        // warehouse_segmetns.appgraph_plus and TransmissionRestrictionService.getRestrictions both
        // use that constant to test for appgraph_plus flags
        id: 'appengagementpersonas',
        type: 'partner_data',
        field: 'attribute_id',
        tag: 'AppGraph+',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'Device Type',
        id: 'devicetype',
        type: 'device_model',
        field: 'device_model',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'Apps Owned by Genre',
        id: 'genre',
        type: 'genre',
        field: 'genre',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'Device Language',
        id: 'language',
        type: 'language',
        field: 'language',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'DMA',
        id: 'location',
        type: 'location',
        field: 'location',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'Median Income',
        id: 'medianincome',
        type: 'median_income',
        field: 'location_zip',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'Ownership Persona',
        id: 'persona',
        type: 'persona',
        field: 'persona',
        tag: 'AppGraph',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'Platform',
        id: 'platform',
        type: 'platform',
        field: 'platform',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'Carrier',
        id: 'carrier',
        type: 'carrier',
        field: 'carrier',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'App Ownership',
        id: 'appownership',
        type: 'app_ownership',
        field: 'mobile_app_id',
        tag: 'AppGraph',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: '1st Party Audience',
        id: 'customaudience',
        type: 'custom_audience',
        field: 'audience_id',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'Demographics',
        id: 'ps_demographics',
        type: 'ps_demographics',
        field: 'ps_demographics',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'SDK Audience',
        id: 'sdk_event',
        type: 'sdk_event',
        field: 'sdk_event',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'Manufacturer',
        id: 'manufacturer',
        type: 'manufacturer',
        field: 'manufacturer',
        partner: publicConstants.SegmentContributingPartners.PushSpring,
        orgId: 0,
    },
    {
        name: 'CUEBIQ Retail Visits',
        id: 'cuebiq',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Cuebiq,
        orgId: 506,
    },
    {
        name: 'Pinsight',
        id: 'pinsight',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Pinsight,
        orgId: 726,
    },
    {
        name: 'Location Behavior',
        id: 'placecast',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Placecast,
        orgId: 240,
    },
    {
        name: 'Stirista',
        id: 'stirista',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Stirista,
        orgId: 925,
    },
    {
        name: 'Bombora',
        id: 'bombora',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Bombora,
        orgId: 923,
    },
    {
        name: 'Ameribase Digital',
        id: 'ameribase',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.AmeribaseDigital,
        orgId: 924,
    },
    {
        name: 'SMS',
        id: 'sms',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.SMS,
        orgId: 922,
    },
    {
        name: 'V12',
        id: 'v12',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.V12,
        orgId: 949,
    },
    {
        name: 'PlaceIQ',
        id: 'placeiq',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.PlaceIQ,
        orgId: 632,
    },
    {
        name: 'Scanbuy',
        id: 'scanbuy',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Scanbuy,
        orgId: 735,
    },
    {
        name: 'TiVo',
        id: 'tivo',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.tivo,
        orgId: 1037,
    },
    {
        name: 'Gravy',
        id: 'gravy',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Gravy,
        orgId: 952,
    },
    {
        name: 'IRI',
        id: 'iri',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.iri,
        orgId: 1048,
    },
    {
        name: 'Alliant',
        id: 'alliant',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Alliant,
        orgId: 1068,
    },
    {
        name: 'Clickagy',
        id: 'clickagy',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Clickagy,
        orgId: 1047,
    },
    {
        name: '180byTwo',
        id: '180bytwo',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.oneeightybytwo,
        orgId: 1921,
    },
    {
        name: 'Reveal',
        id: 'reveal',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Reveal,
        orgId: 1065,
    },
    {
        name: 'Epsilon',
        id: 'epsilon',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Epsilon,
        orgId: 1082,
    },
    {
        name: 'ASL Marketing',
        id: 'aslmarketing',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.ASLMarketing,
        orgId: 1113,
    },
    {
        name: 'Share This',
        id: 'sharethis',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.ShareThis,
        orgId: 1112,
    },
    {
        name: 'NinthDecimal',
        id: 'ninthdecimal',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.NinthDecimal,
        orgId: 1114,
    },
    {
        name: 'AnalyticsIQ',
        id: 'analyticsiq',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.AnalyticsIQ,
        orgId: 1145,
    },
    {
        name: 'LOCALLY',
        id: 'locally',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Locally,
        orgId: 1151,
    },
    {
        name: 'Affinity Answers',
        id: 'affinityanswers',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.AffinityAnswers,
        orgId: 1188,
    },
    {
        name: 'Affinity Solutions',
        id: 'affinitysolutions',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.AffinitySolutions,
        orgId: 1189,
    },
    {
        name: 'MeritDirect',
        id: 'meritdirect',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.MeritDirect,
        orgId: 1224,
    },
    {
        name: 'StatSocial',
        id: 'statsocial',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.StatSocial,
        orgId: 1235,
    },
    {
        name: 'Skyhook',
        id: 'skyhook',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Skyhook,
        orgId: 1237,
    },
    {
        name: 'Audigent',
        id: 'audigent',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Audigent,
        orgId: 1236,
    },
    {
        name: 'Cross Pixel',
        id: 'crosspixel',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.CrossPixel,
        orgId: 1241,
    },
    {
        name: 'PeerLogix',
        id: 'peerlogix',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.PeerLogix,
        orgId: 1255,
    },
    {
        name: 'Webbula',
        id: 'webbula',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Webbula,
        orgId: 1264,
    },
    {
        name: 'Claritas',
        id: 'claritas',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.Claritas,
        orgId: 1268,
    },
    {
        name: '33Across',
        id: '33across',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.thirtythreeacross,
        orgId: 1269,
    },
    {
        name: 'DishTV',
        id: 'dishtv',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.dishtv,
        orgId: 1281,
    },
    {
        name: 'Insticator',
        id: 'insticator',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.insticator,
        orgId: 1347,
    },
    {
        name: 'Adstra',
        id: 'alc',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.alc,
        orgId: 1373,
    },
    {
        name: 'X-Mode',
        id: 'xmode',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.xmode,
        orgId: 729,
    },
    {
        name: 'Bridge',
        id: 'bridge',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.bridge,
        orgId: 1390,
    },
    {
        name: 'Dstillery',
        id: 'dstillery',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.dstillery,
        orgId: 1399,
    },
    {
        name: '180byTwo',
        id: '180bytwodirect',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.oneeightybytwodirect,
        orgId: 1405,
    },
    {
        name: 'Wiland',
        id: 'wiland',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.wiland,
        orgId: 1440,
    },
    {
        name: 'Reklaim',
        id: 'killi',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.killi,
        orgId: 1476,
    },
    {
        name: 'Equifax',
        id: 'equifax',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.equifax,
        orgId: 1475,
    },
    {
        name: 'Data Axle',
        id: 'dataaxle',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.dataaxle,
        orgId: 1488,
    },
    {
        name: 'Fyllo',
        id: 'fyllo',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.fyllo,
        orgId: 1311,
    },
    {
        name: 'Test',
        id: 'test',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.test,
        orgId: 69,
    },
    {
        name: 'T-Mobile Data Engineering',
        id: 'tmobiledataengineering',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.tmobiledataengineering,
        orgId: 1558,
    },
    {
        name: 'Catalina',
        id: 'catalina',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.catalina,
        orgId: 1513,
    },
    {
        name: 'Foursquare',
        id: 'foursquare',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.foursquare,
        orgId: 1588,
    },
    {
        name: 'InMarket',
        id: 'inmarket',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.inmarket,
        orgId: 1600,
    },
    {
        name: 'AmeriLink',
        id: 'amerilink',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.amerilink,
        orgId: 1589,
    },
    {
        name: 'TiVo/BDEX',
        id: 'tivobdex',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.tivobdex,
        orgId: 1601,
    },
    {
        name: 'PlaceIQ',
        id: 'placeiqdirect',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.placeiqdirect,
        orgId: 1591,
    },
    {
        name: 'Start.io',
        id: 'startio',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.startio,
        orgId: 1696,
    },
    {
        name: 'AnalyticsIQ',
        id: 'analyticsiqdirect',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.analyticsiqdirect,
        orgId: 1741,
    },
    {
        name: 'Polk Audiences by S&P Global Mobility',
        id: 'ihsmarkitpolk',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.ihsmarkitpolk,
        orgId: 1761,
    },
    {
        name: 'Comscore',
        id: 'comscore',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.comscore,
        orgId: 1841,
    },
    {
        name: 'CIS',
        id: 'cis',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.cis,
        orgId: 1842,
    },
    {
        name: 'Homedata',
        id: 'homedata',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.homedata,
        orgId: 1843,
    },
    {
        name: 'Samba TV',
        id: 'sambatv',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.sambatv,
        orgId: 1880,
    },
    {
        name: 'Loopme',
        id: 'loopme',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.loopme,
        orgId: 1881,
    },
    {
        name: 'Deep Sync',
        id: 'deepsync',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.deepsync,
        orgId: 1889,
    },
    {
        name: 'Sliide',
        id: 'sliide',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.sliide,
        orgId: 1974,
    },
    {
        name: 'Unity',
        id: 'unity',
        type: 'partner_data',
        field: 'attribute_id',
        partner: publicConstants.SegmentContributingPartners.unity,
        orgId: 763,
    },
];

// Shared between server (eventotron) and client (partner UI) so both sides agree on the
// exact header name/casing for paginated endpoints like GET /v1/marketplace/attribute.
publicConstants.PaginationHeaders = {
    NEXT_OFFSET: 'x-next-offset',
};

// Used in snowflakeSegmentQueryBuilder.js to determine when a LEFT JOIN rather than an INNER JOIN
// should be used against thirdparty_personas_optimized
// Used to recognize old-schema segment attributes for backward compatibility, e.g. cuebiq
publicConstants.PartnerAttributeTypes = [
    'sliide',
    'unity',
    'deepsync',
    'appengagementpersonas',
    'cuebiq',
    'placecast',
    'pinsight',
    'v12',
    'sms',
    'bombora',
    'stirista',
    'placeiq',
    'tivo',
    'gravy',
    'iri',
    'alliant',
    'clickagy',
    'test',
    '180bytwo',
    'reveal',
    'epsilon',
    'aslmarketing',
    'sharethis',
    'ninthdecimal',
    'analyticsiq',
    'locally',
    'affinityanswers',
    'affinitysolutions',
    'meritdirect',
    'statsocial',
    'skyhook',
    'audigent',
    'crosspixel',
    'peerlogix',
    'webbula',
    'claritas',
    '33across',
    'dishtv',
    'statsocial',
    'insticator',
    'alc',
    'xmode',
    'bridge',
    'dstillery',
    '180bytwodirect',
    'wiland',
    'equifax',
    'killi',
    'dataaxle',
    'fyllo',
    'tmobiledataengineering',
    'catalina',
    'foursquare',
    'inmarket',
    'amerilink',
    'tivobdex',
    'placeiqdirect',
    'startio',
    'analyticsiqdirect',
    'appengagementapps',
    'ihsmarkitpolk',
    'comscore',
    'cis',
    'homedata',
    'sambatv',
    'loopme',
];

// Controls the UI in custom segment builder: order is the order they will appear onscreen in segment editor
// Should be alphabetized for just the partners at the end
publicConstants.explorerAttributes = [
    'appengagementapps',
    'appengagementpersonas',
    'appownership',
    'persona',
    'ps_demographics',
    'genre',
    'manufacturer',
    'carrier',
    'platform',
    'customaudience',
    'language',
    '180bytwo',
    '33across',
    'affinityanswers',
    'affinitysolutions',
    'alc',
    'alliant',
    'ameribase',
    'analyticsiq',
    'aslmarketing',
    'bombora',
    'cis',
    'claritas',
    'clickagy',
    'comscore',
    'crosspixel',
    'dataaxle',
    'deepsync',
    'dstillery',
    'epsilon',
    'equifax',
    'foursquare',
    'fyllo',
    'gravy',
    'homedata',
    'iri',
    'ihsmarkitpolk',
    'inmarket',
    'loopme',
    'ninthdecimal',
    'placeiqdirect',
    'sambatv',
    'sharethis',
    'sms',
    'startio',
    'stirista',
    'tivobdex',
    'v12',
    'webbula',
    'wiland',
    'sliide',
    'unity',
];

// Indicates supported attributes in the query builder. You can add a new type here to test the calculations
// in production before showing it in the UI or support a legacy attribute after it has been removed from
// the UI.
// Should be an id for the partner types
publicConstants.QueryBuilderAttributes = [
    'sliide',
    'unity',
    'deepsync',
    'appengagementpersonas',
    'appengagementapps',
    'appownership',
    'persona',
    'genre',
    'devicetype',
    'manufacturer',
    'location',
    'carrier',
    'platform',
    'customaudience',
    'sdk_event',
    'language',
    'cuebiq',
    'pinsight',
    'placecast',
    'placeiqdirect',
    'stirista',
    'bombora',
    'sms',
    'ameribase',
    'v12',
    'placeiq',
    'ps_demographics',
    'scanbuy',
    'tivo',
    'gravy',
    'iri',
    'alliant',
    'clickagy',
    'test',
    '180bytwo',
    'reveal',
    'epsilon',
    'aslmarketing',
    'sharethis',
    'ninthdecimal',
    'analyticsiq',
    'locally',
    'affinityanswers',
    'affinitysolutions',
    'meritdirect',
    'statsocial',
    'skyhook',
    'audigent',
    'crosspixel',
    'peerlogix',
    'webbula',
    'claritas',
    '33across',
    'dishtv',
    'statsocial',
    'insticator',
    'alc',
    'xmode',
    'bridge',
    'dstillery',
    '180bytwodirect',
    'wiland',
    'equifax',
    'killi',
    'dataaxle',
    'fyllo',
    'tmobiledataengineering',
    'catalina',
    'foursquare',
    'inmarket',
    'amerilink',
    'tivobdex',
    'startio',
    'analyticsiqdirect',
    'ihsmarkitpolk',
    'comscore',
    'cis',
    'homedata',
    'sambatv',
    'loopme',
];

publicConstants.AllowedExplorerSegmentAttributes = [];
publicConstants.explorerAttributes.forEach((attribute) => {
    publicConstants.AllowedExplorerSegmentAttributes.push(
        publicConstants.AllowedSegmentAttributes.find(function (obj) {
            return obj.id === attribute;
        }),
    );
});

// Only used in explorer
const SegmentModifierSubtype = {
    CountryCode: 1,
    StateCode: 2,
    ZipCode: 3,
    ZipList: 4,
    DMA: 5,
    DeviceModel: 6,
    DeviceManufacturer: 7,
    Gender: 8,
    MedianIncome: 9,
    Persona: 10,
    Platform: 11,
    Carrier: 12,
    MobileApp: 13,
    CustomAudience: 14,
    Genre: 15,
    Distance: 16,
    EventCount: 17,
    EventFirstOccurrence: 18,
    EventLastOccurrence: 19,
    ComscoreAge: 20,
    ComscoreIncome: 21,
    ComscoreGender: 22,
    ComscoreEducation: 23,
    Language: 24,
    SDKAudience: 25,
    PartnerData: 26,
    Manufacturer: 27,
    PushSpringAge: 28,
    PushSpringGender: 29,
    PushSpringIncome: 30,
};
publicConstants.SegmentModifierSubtype = SegmentModifierSubtype;

const SegmentModifierSubtypeName = {};
SegmentModifierSubtypeName[SegmentModifierSubtype.CountryCode] = 'Country Code';
SegmentModifierSubtypeName[SegmentModifierSubtype.StateCode] = 'State Code';
SegmentModifierSubtypeName[SegmentModifierSubtype.ZipCode] = 'Zip Code';
SegmentModifierSubtypeName[SegmentModifierSubtype.ZipList] = 'Zip List';
SegmentModifierSubtypeName[SegmentModifierSubtype.DMA] = 'DMA';
SegmentModifierSubtypeName[SegmentModifierSubtype.DeviceModel] = 'Device Model';
SegmentModifierSubtypeName[SegmentModifierSubtype.DeviceManufacturer] = 'Device Manufacturer';
SegmentModifierSubtypeName[SegmentModifierSubtype.Gender] = 'Gender';
SegmentModifierSubtypeName[SegmentModifierSubtype.MedianIncome] = 'Median Income';
SegmentModifierSubtypeName[SegmentModifierSubtype.Persona] = 'Persona';
SegmentModifierSubtypeName[SegmentModifierSubtype.Platform] = 'Platform';
SegmentModifierSubtypeName[SegmentModifierSubtype.Carrier] = 'Carrier';
SegmentModifierSubtypeName[SegmentModifierSubtype.MobileApp] = 'Mobile App';
SegmentModifierSubtypeName[SegmentModifierSubtype.CustomAudience] = 'Custom Audience';
SegmentModifierSubtypeName[SegmentModifierSubtype.Genre] = 'Genre';
SegmentModifierSubtypeName[SegmentModifierSubtype.Distance] = 'Distance';
SegmentModifierSubtypeName[SegmentModifierSubtype.EventCount] = 'Event Count';
SegmentModifierSubtypeName[SegmentModifierSubtype.EventFirstOccurrence] = 'Event First Occurrence';
SegmentModifierSubtypeName[SegmentModifierSubtype.EventLastOccurrence] = 'Event Last Occurrence';
SegmentModifierSubtypeName[SegmentModifierSubtype.ComscoreAge] = 'comScore Age';
SegmentModifierSubtypeName[SegmentModifierSubtype.ComscoreIncome] = 'comScore Income';
SegmentModifierSubtypeName[SegmentModifierSubtype.ComscoreGender] = 'comScore Gender';
SegmentModifierSubtypeName[SegmentModifierSubtype.ComscoreEducation] = 'comScore Education';
SegmentModifierSubtypeName[SegmentModifierSubtype.Language] = 'Device Language';
SegmentModifierSubtypeName[SegmentModifierSubtype.SDKAudience] = 'SDK Audience';
SegmentModifierSubtypeName[SegmentModifierSubtype.Manufacturer] = 'Manufacturer';
SegmentModifierSubtypeName[SegmentModifierSubtype.PartnerData] = 'Partner Data';

publicConstants.SegmentModifierSubtypeName = SegmentModifierSubtypeName;

// Subtypes are required for Exploratron. If you add a new modifier that will be used
// in the Explorer, add a subType, and if one doesn't match, add a new one to the subType
// constants.
const AllowedSegmentModifiers = {
    carrier: [
        { name: 'is', op: '=', requiredValue: true, subType: SegmentModifierSubtype.Carrier },
        { name: 'is not', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.Carrier },
        { name: 'is', op: '$exists', requiredValue: true, subType: SegmentModifierSubtype.Carrier },
        { name: 'is not', op: '$notexists', requiredValue: true, subType: SegmentModifierSubtype.Carrier },
    ],
    language: [
        { name: 'is', op: '=', requiredValue: true, subType: SegmentModifierSubtype.Language },
        { name: 'is not', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.Language },
    ],
    location: [
        { name: 'is in country', op: '$countryCode', requiredValue: true, subType: SegmentModifierSubtype.CountryCode },
        {
            name: 'is not in country',
            op: '$notcountryCode',
            requiredValue: true,
            subType: SegmentModifierSubtype.CountryCode,
        },
        { name: 'is in US state', op: '$stateCode', requiredValue: true, subType: SegmentModifierSubtype.StateCode },
        {
            name: 'is not in US state',
            op: '$notstateCode',
            requiredValue: true,
            subType: SegmentModifierSubtype.StateCode,
        },
        { name: 'is US Zip Code', op: '$zip', requiredValue: true, subType: SegmentModifierSubtype.ZipCode },
        { name: 'is not US Zip Code', op: '$notzip', requiredValue: true, subType: SegmentModifierSubtype.ZipCode },
        {
            name: 'is in US Zip Code List',
            op: '$ziplist',
            requiredValue: true,
            subType: SegmentModifierSubtype.ZipList,
        },
        {
            name: 'is not in US Zip Code List',
            op: '$notziplist',
            requiredValue: true,
            subType: SegmentModifierSubtype.ZipList,
        },
        { name: 'is in Marketing Area', op: '$dma', requiredValue: true, subType: SegmentModifierSubtype.DMA },
        { name: 'is not in Marketing Area', op: '$notdma', requiredValue: true, subType: SegmentModifierSubtype.DMA },
        { name: 'is within distance', op: '$distance', requiredValue: true, subType: SegmentModifierSubtype.Distance },
    ],
    median_income: [
        { name: 'is at least', op: '>=', requiredValue: true, subType: SegmentModifierSubtype.MedianIncome },
        { name: 'is at most', op: '<=', requiredValue: true, subType: SegmentModifierSubtype.MedianIncome },
        { name: 'is exactly', op: '=', requiredValue: true, subType: SegmentModifierSubtype.MedianIncome },
    ],
    persona: [
        { name: 'is', op: '=', requiredValue: true, subType: SegmentModifierSubtype.Persona },
        { name: 'is not', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.Persona },
    ],
    platform: [
        { name: 'is', op: '=', requiredValue: true, subType: SegmentModifierSubtype.Platform },
        { name: 'is not', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.Platform },
    ],
    genre: [
        { name: 'App Genre is', op: '=', requiredValue: true, subType: SegmentModifierSubtype.Genre },
        { name: 'App Genre is not', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.Genre },
    ],
    app_ownership: [
        { name: 'has any', op: '$exists', requiredValue: true, subType: SegmentModifierSubtype.MobileApp },
        { name: 'has none', op: '$notexists', requiredValue: true, subType: SegmentModifierSubtype.MobileApp },
        { name: 'has at least', op: 'count_at_least', requiredValue: true, subType: SegmentModifierSubtype.MobileApp },
        { name: 'has exactly', op: 'count_exactly', requiredValue: true, subType: SegmentModifierSubtype.MobileApp },
    ],
    device_model: [
        { name: 'model is', op: '=', requiredValue: true, subType: SegmentModifierSubtype.DeviceModel },
        { name: 'model is not', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.DeviceModel },
        { name: 'manufacturer is', op: 'm=', requiredValue: true, subType: SegmentModifierSubtype.DeviceManufacturer },
        {
            name: 'manufacturer is not',
            op: 'm!=',
            requiredValue: true,
            subType: SegmentModifierSubtype.DeviceManufacturer,
        },
    ],
    custom_audience: [
        { name: 'is in', op: '=', requiredValue: true, subType: SegmentModifierSubtype.CustomAudience },
        { name: 'is not in', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.CustomAudience },
        { name: 'more than', op: 'count_more_than', requiredValue: true, subType: SegmentModifierSubtype.EventCount },
        { name: 'exactly', op: 'count_exactly', requiredValue: true, subType: SegmentModifierSubtype.EventCount },
        { name: 'less than', op: 'count_less_than', requiredValue: true, subType: SegmentModifierSubtype.EventCount },
        {
            name: 'before',
            op: 'first_before',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: false,
        },
        {
            name: 'after',
            op: 'first_after',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: false,
        },
        {
            name: 'on',
            op: 'first_on',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: false,
        },
        {
            name: 'more than',
            op: 'first_more_than',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: true,
        },
        {
            name: 'exactly',
            op: 'first_exactly',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: true,
        },
        {
            name: 'less than',
            op: 'first_less_than',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: true,
        },
        {
            name: 'before',
            op: 'last_before',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: false,
        },
        {
            name: 'after',
            op: 'last_after',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: false,
        },
        {
            name: 'on',
            op: 'last_on',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: false,
        },
        {
            name: 'more than',
            op: 'last_more_than',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: true,
        },
        {
            name: 'exactly',
            op: 'last_exactly',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: true,
        },
        {
            name: 'less than',
            op: 'last_less_than',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: true,
        },
    ],
    sdk_event: [
        { name: 'more than', op: 'count_more_than', requiredValue: true, subType: SegmentModifierSubtype.EventCount },
        { name: 'exactly', op: 'count_exactly', requiredValue: true, subType: SegmentModifierSubtype.EventCount },
        { name: 'less than', op: 'count_less_than', requiredValue: true, subType: SegmentModifierSubtype.EventCount },
        {
            name: 'before',
            op: 'first_before',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: false,
        },
        {
            name: 'after',
            op: 'first_after',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: false,
        },
        {
            name: 'on',
            op: 'first_on',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: false,
        },
        {
            name: 'more than',
            op: 'first_more_than',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: true,
        },
        {
            name: 'exactly',
            op: 'first_exactly',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: true,
        },
        {
            name: 'less than',
            op: 'first_less_than',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventFirstOccurrence,
            isRelative: true,
        },
        {
            name: 'before',
            op: 'last_before',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: false,
        },
        {
            name: 'after',
            op: 'last_after',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: false,
        },
        {
            name: 'on',
            op: 'last_on',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: false,
        },
        {
            name: 'more than',
            op: 'last_more_than',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: true,
        },
        {
            name: 'exactly',
            op: 'last_exactly',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: true,
        },
        {
            name: 'less than',
            op: 'last_less_than',
            requiredValue: true,
            subType: SegmentModifierSubtype.EventLastOccurrence,
            isRelative: true,
        },
        { name: 'is in', op: '=', requiredValue: true, subType: SegmentModifierSubtype.SDKAudience },
        { name: 'is not in', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.SDKAudience },
    ],
    partner_data: [
        { name: 'is in', op: '=', requiredValue: true, subType: SegmentModifierSubtype.PartnerData },
        { name: 'is not in', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.PartnerData },
    ],
    // Kept for old segments, no longer used
    cuebiq: [
        { name: 'is in', op: '=', requiredValue: true, subType: SegmentModifierSubtype.PartnerData },
        { name: 'is not in', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.PartnerData },
    ],
    // Kept for old segments, no longer used
    pinsight: [
        { name: 'is in', op: '=', requiredValue: true, subType: SegmentModifierSubtype.PartnerData },
        { name: 'is not in', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.PartnerData },
    ],
    // Kept for old segments, no longer used
    placecast: [
        { name: 'is in', op: '=', requiredValue: true, subType: SegmentModifierSubtype.PartnerData },
        { name: 'is not in', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.PartnerData },
    ],
    manufacturer: [
        { name: 'is', op: '=', requiredValue: true, subType: SegmentModifierSubtype.Manufacturer },
        { name: 'is not', op: '!=', requiredValue: true, subType: SegmentModifierSubtype.Manufacturer },
    ],
    ps_demographics: [
        { name: 'Gender is', op: '$gender', requiredValue: true, subType: SegmentModifierSubtype.PushSpringGender },
        {
            name: 'Gender is not',
            op: '$notGender',
            requiredValue: true,
            subType: SegmentModifierSubtype.PushSpringGender,
        },
        { name: 'Age is', op: '$age', requiredValue: true, subType: SegmentModifierSubtype.PushSpringAge },
        { name: 'Age is not', op: '$notage', requiredValue: true, subType: SegmentModifierSubtype.PushSpringAge },
        {
            name: 'Household Income is',
            op: '$income',
            requiredValue: true,
            subType: SegmentModifierSubtype.PushSpringIncome,
        },
        {
            name: 'Household Income is not',
            op: '$notincome',
            requiredValue: true,
            subType: SegmentModifierSubtype.PushSpringIncome,
        },
    ],
};

publicConstants.AllowedSegmentModifiers = AllowedSegmentModifiers;

// Lookup subtype by rule type and modifier op
const SegmentModifierLookup = {};
Object.entries(AllowedSegmentModifiers).forEach(([key, modifiers]) => {
    Object.values(modifiers).forEach((modifier) => {
        if (!SegmentModifierLookup[key]) {
            SegmentModifierLookup[key] = {};
        }
        SegmentModifierLookup[key][modifier.op] = modifier;
    });
});

publicConstants.SegmentModifierLookup = SegmentModifierLookup;

publicConstants.AllowedSegmentLanguages = {
    English: 'en',
    Abkhazian: 'ab',
    Afar: 'aa',
    Afrikaans: 'af',
    Akan: 'ak',
    Albanian: 'sq',
    Amharic: 'am',
    Arabic: 'ar',
    Aragonese: 'an',
    Armenian: 'hy',
    Assamese: 'as',
    Avaric: 'av',
    Avestan: 'ae',
    Aymara: 'ay',
    Azerbaijani: 'az',
    Bambara: 'bm',
    Bashkir: 'ba',
    Basque: 'eu',
    Belarusian: 'be',
    Bengali: 'bn',
    Bislama: 'bi',
    Bosnian: 'bs',
    Breton: 'br',
    Bulgarian: 'bg',
    Burmese: 'my',
    Catalan: 'ca',
    'Central Khmer': 'km',
    Chamorro: 'ch',
    Chechen: 'ce',
    Chewa: 'ny',
    Chinese: 'zh',
    // Shows up with almost no results in our thirdparty_devices dataset
    // "Chinese ": "cn",
    Chuang: 'za',
    'Church Slavic': 'cu',
    Chuvash: 'cv',
    Cornish: 'kw',
    Corsican: 'co',
    Cree: 'cr',
    Croatian: 'hr',
    Czech: 'cs',
    Danish: 'da',
    Dhivehi: 'dv',
    Dutch: 'nl',
    Dzongkha: 'dz',
    Esperanto: 'eo',
    Estonian: 'et',
    Ewe: 'ee',
    Faroese: 'fo',
    Fijian: 'fj',
    Finnish: 'fi',
    Flemish: 'nl',
    French: 'fr',
    Fulah: 'ff',
    Gaelic: 'gd',
    Galician: 'gl',
    Ganda: 'lg',
    Georgian: 'ka',
    German: 'de',
    Gikuyu: 'ki',
    Greek: 'el',
    Greenlandic: 'kl',
    Guarani: 'gn',
    Gujarati: 'gu',
    Haitian: 'ht',
    Hausa: 'ha',
    Hebrew: 'he',
    Herero: 'hz',
    Hindi: 'hi',
    'Hiri Motu': 'ho',
    Hungarian: 'hu',
    Icelandic: 'is',
    Ido: 'io',
    Igbo: 'ig',
    Indonesian: 'id',
    Interlingua: 'ia',
    Interlingue: 'ie',
    Inuktitut: 'iu',
    Inupiaq: 'ik',
    Irish: 'ga',
    Italian: 'it',
    Japanese: 'ja',
    'Japanese ': 'jp',
    Javanese: 'jv',
    Kalaallisut: 'kl',
    Kannada: 'kn',
    Kanuri: 'kr',
    Kashmiri: 'ks',
    Kazakh: 'kk',
    Kikuyu: 'ki',
    Kinyarwanda: 'rw',
    Kirghiz: 'ky',
    Komi: 'kv',
    Kongo: 'kg',
    Korean: 'ko',
    Kuanyama: 'kj',
    Kurdish: 'ku',
    Kwanyama: 'kj',
    Kyrgyz: 'ky',
    Lao: 'lo',
    Latin: 'la',
    Latvian: 'lv',
    Letzeburgesch: 'lb',
    Limburgan: 'll',
    Lingala: 'ln',
    Lithuanian: 'lt',
    'Luba-Katanga': 'lu',
    Luxembourgish: 'lb',
    Macedonian: 'mk',
    Malagasy: 'mg',
    Malay: 'ms',
    Malayalam: 'ml',
    Maldivian: 'dv',
    Maltese: 'mt',
    Manx: 'gv',
    Maori: 'mi',
    Marathi: 'mr',
    Marshallese: 'mh',
    Moldovan: 'ro',
    Mongolian: 'mn',
    Nauru: 'na',
    Navajo: 'nv',
    'Ndebele, North': 'nd',
    'Ndebele, South': 'nr',
    Ndonga: 'ng',
    Nepali: 'ne',
    'Northern Sami': 'se',
    Norwegian: 'no',
    'Norwegian Bokmål': 'nb',
    'Norwegian Nynorsk': 'nn',
    Nuosu: 'ii',
    Nyanja: 'ny',
    Occidental: 'ie',
    Occitan: 'oc',
    Ojibwa: 'oj',
    Oriya: 'or',
    Oromo: 'om',
    Ossetic: 'os',
    Pali: 'pi',
    Pashto: 'ps',
    Persian: 'fa',
    Polish: 'pl',
    Portuguese: 'pt',
    Punjabi: 'pa',
    Quechua: 'qu',
    Romanian: 'ro',
    Romansh: 'rm',
    Rundi: 'rn',
    Russian: 'ru',
    Samoan: 'sm',
    Sango: 'sg',
    Sanskrit: 'sa',
    Sardinian: 'sc',
    Serbian: 'sr',
    Shona: 'sn',
    'Sichuan Yi': 'ii',
    Sindhi: 'sd',
    Sinhalese: 'si',
    Slovak: 'sk',
    Slovenian: 'sl',
    Somali: 'so',
    Sotho: 'st',
    Spanish: 'es',
    Sundanese: 'su',
    Swahili: 'sw',
    Swati: 'ss',
    Swedish: 'sv',
    Tagalog: 'tl',
    Tahitian: 'ty',
    Tajik: 'tg',
    Tamil: 'ta',
    Tatar: 'tt',
    Telugu: 'te',
    Thai: 'th',
    Tibetan: 'bo',
    Tigrinya: 'ti',
    Tonga: 'to',
    Tsonga: 'ts',
    Tswana: 'tn',
    Turkish: 'tr',
    Turkmen: 'tk',
    Twi: 'tw',
    Ulghur: 'ug',
    Ukrainian: 'uk',
    Urdu: 'ur',
    Uyghur: 'ug',
    Uzbek: 'uz',
    Valencian: 'ca',
    Venda: 've',
    Vietnamese: 'vi',
    Volapük: 'vo',
    Walloon: 'wa',
    Welsh: 'cy',
    'Western Frisian': 'fy',
    Wolof: 'wo',
    Xhosa: 'xh',
    Yiddish: 'yi',
    Yoruba: 'yo',
    Zenaga: 'za',
    Zulu: 'zu',
};

// countries json from https://github.com/lukes/ISO-3166-Countries-with-Regional-Codes/edit/master/slim-2/slim-2.json

publicConstants.AllowedSegmentCountries = [
    { name: 'Afghanistan', 'alpha-2': 'AF', 'country-code': '004' },
    { name: 'Åland Islands', 'alpha-2': 'AX', 'country-code': '248' },
    { name: 'Albania', 'alpha-2': 'AL', 'country-code': '008' },
    { name: 'Algeria', 'alpha-2': 'DZ', 'country-code': '012' },
    { name: 'American Samoa', 'alpha-2': 'AS', 'country-code': '016' },
    { name: 'Andorra', 'alpha-2': 'AD', 'country-code': '020' },
    { name: 'Angola', 'alpha-2': 'AO', 'country-code': '024' },
    { name: 'Anguilla', 'alpha-2': 'AI', 'country-code': '660' },
    { name: 'Antarctica', 'alpha-2': 'AQ', 'country-code': '010' },
    { name: 'Antigua and Barbuda', 'alpha-2': 'AG', 'country-code': '028' },
    { name: 'Argentina', 'alpha-2': 'AR', 'country-code': '032' },
    { name: 'Armenia', 'alpha-2': 'AM', 'country-code': '051' },
    { name: 'Aruba', 'alpha-2': 'AW', 'country-code': '533' },
    { name: 'Australia', 'alpha-2': 'AU', 'country-code': '036' },
    { name: 'Austria', 'alpha-2': 'AT', 'country-code': '040' },
    { name: 'Azerbaijan', 'alpha-2': 'AZ', 'country-code': '031' },
    { name: 'Bahamas', 'alpha-2': 'BS', 'country-code': '044' },
    { name: 'Bahrain', 'alpha-2': 'BH', 'country-code': '048' },
    { name: 'Bangladesh', 'alpha-2': 'BD', 'country-code': '050' },
    { name: 'Barbados', 'alpha-2': 'BB', 'country-code': '052' },
    { name: 'Belarus', 'alpha-2': 'BY', 'country-code': '112' },
    { name: 'Belgium', 'alpha-2': 'BE', 'country-code': '056' },
    { name: 'Belize', 'alpha-2': 'BZ', 'country-code': '084' },
    { name: 'Benin', 'alpha-2': 'BJ', 'country-code': '204' },
    { name: 'Bermuda', 'alpha-2': 'BM', 'country-code': '060' },
    { name: 'Bhutan', 'alpha-2': 'BT', 'country-code': '064' },
    { name: 'Bolivia, Plurinational State of', 'alpha-2': 'BO', 'country-code': '068' },
    { name: 'Bonaire, Sint Eustatius and Saba', 'alpha-2': 'BQ', 'country-code': '535' },
    { name: 'Bosnia and Herzegovina', 'alpha-2': 'BA', 'country-code': '070' },
    { name: 'Botswana', 'alpha-2': 'BW', 'country-code': '072' },
    { name: 'Bouvet Island', 'alpha-2': 'BV', 'country-code': '074' },
    { name: 'Brazil', 'alpha-2': 'BR', 'country-code': '076' },
    { name: 'British Indian Ocean Territory', 'alpha-2': 'IO', 'country-code': '086' },
    { name: 'Brunei Darussalam', 'alpha-2': 'BN', 'country-code': '096' },
    { name: 'Bulgaria', 'alpha-2': 'BG', 'country-code': '100' },
    { name: 'Burkina Faso', 'alpha-2': 'BF', 'country-code': '854' },
    { name: 'Burundi', 'alpha-2': 'BI', 'country-code': '108' },
    { name: 'Cambodia', 'alpha-2': 'KH', 'country-code': '116' },
    { name: 'Cameroon', 'alpha-2': 'CM', 'country-code': '120' },
    { name: 'Canada', 'alpha-2': 'CA', 'country-code': '124' },
    { name: 'Cape Verde', 'alpha-2': 'CV', 'country-code': '132' },
    { name: 'Cayman Islands', 'alpha-2': 'KY', 'country-code': '136' },
    { name: 'Central African Republic', 'alpha-2': 'CF', 'country-code': '140' },
    { name: 'Chad', 'alpha-2': 'TD', 'country-code': '148' },
    { name: 'Chile', 'alpha-2': 'CL', 'country-code': '152' },
    { name: 'China', 'alpha-2': 'CN', 'country-code': '156' },
    { name: 'Christmas Island', 'alpha-2': 'CX', 'country-code': '162' },
    { name: 'Cocos (Keeling) Islands', 'alpha-2': 'CC', 'country-code': '166' },
    { name: 'Colombia', 'alpha-2': 'CO', 'country-code': '170' },
    { name: 'Comoros', 'alpha-2': 'KM', 'country-code': '174' },
    { name: 'Congo', 'alpha-2': 'CG', 'country-code': '178' },
    { name: 'Congo, the Democratic Republic of the', 'alpha-2': 'CD', 'country-code': '180' },
    { name: 'Cook Islands', 'alpha-2': 'CK', 'country-code': '184' },
    { name: 'Costa Rica', 'alpha-2': 'CR', 'country-code': '188' },
    { name: "Côte d'Ivoire", 'alpha-2': 'CI', 'country-code': '384' },
    { name: 'Croatia', 'alpha-2': 'HR', 'country-code': '191' },
    { name: 'Cuba', 'alpha-2': 'CU', 'country-code': '192' },
    { name: 'Curaçao', 'alpha-2': 'CW', 'country-code': '531' },
    { name: 'Cyprus', 'alpha-2': 'CY', 'country-code': '196' },
    { name: 'Czech Republic', 'alpha-2': 'CZ', 'country-code': '203' },
    { name: 'Denmark', 'alpha-2': 'DK', 'country-code': '208' },
    { name: 'Djibouti', 'alpha-2': 'DJ', 'country-code': '262' },
    { name: 'Dominica', 'alpha-2': 'DM', 'country-code': '212' },
    { name: 'Dominican Republic', 'alpha-2': 'DO', 'country-code': '214' },
    { name: 'Ecuador', 'alpha-2': 'EC', 'country-code': '218' },
    { name: 'Egypt', 'alpha-2': 'EG', 'country-code': '818' },
    { name: 'El Salvador', 'alpha-2': 'SV', 'country-code': '222' },
    { name: 'Equatorial Guinea', 'alpha-2': 'GQ', 'country-code': '226' },
    { name: 'Eritrea', 'alpha-2': 'ER', 'country-code': '232' },
    { name: 'Estonia', 'alpha-2': 'EE', 'country-code': '233' },
    { name: 'Ethiopia', 'alpha-2': 'ET', 'country-code': '231' },
    { name: 'Falkland Islands (Malvinas)', 'alpha-2': 'FK', 'country-code': '238' },
    { name: 'Faroe Islands', 'alpha-2': 'FO', 'country-code': '234' },
    { name: 'Fiji', 'alpha-2': 'FJ', 'country-code': '242' },
    { name: 'Finland', 'alpha-2': 'FI', 'country-code': '246' },
    { name: 'France', 'alpha-2': 'FR', 'country-code': '250' },
    { name: 'French Guiana', 'alpha-2': 'GF', 'country-code': '254' },
    { name: 'French Polynesia', 'alpha-2': 'PF', 'country-code': '258' },
    { name: 'French Southern Territories', 'alpha-2': 'TF', 'country-code': '260' },
    { name: 'Gabon', 'alpha-2': 'GA', 'country-code': '266' },
    { name: 'Gambia', 'alpha-2': 'GM', 'country-code': '270' },
    { name: 'Georgia', 'alpha-2': 'GE', 'country-code': '268' },
    { name: 'Germany', 'alpha-2': 'DE', 'country-code': '276' },
    { name: 'Ghana', 'alpha-2': 'GH', 'country-code': '288' },
    { name: 'Gibraltar', 'alpha-2': 'GI', 'country-code': '292' },
    { name: 'Greece', 'alpha-2': 'GR', 'country-code': '300' },
    { name: 'Greenland', 'alpha-2': 'GL', 'country-code': '304' },
    { name: 'Grenada', 'alpha-2': 'GD', 'country-code': '308' },
    { name: 'Guadeloupe', 'alpha-2': 'GP', 'country-code': '312' },
    { name: 'Guam', 'alpha-2': 'GU', 'country-code': '316' },
    { name: 'Guatemala', 'alpha-2': 'GT', 'country-code': '320' },
    { name: 'Guernsey', 'alpha-2': 'GG', 'country-code': '831' },
    { name: 'Guinea', 'alpha-2': 'GN', 'country-code': '324' },
    { name: 'Guinea-Bissau', 'alpha-2': 'GW', 'country-code': '624' },
    { name: 'Guyana', 'alpha-2': 'GY', 'country-code': '328' },
    { name: 'Haiti', 'alpha-2': 'HT', 'country-code': '332' },
    { name: 'Heard Island and McDonald Islands', 'alpha-2': 'HM', 'country-code': '334' },
    { name: 'Holy See (Vatican City State)', 'alpha-2': 'VA', 'country-code': '336' },
    { name: 'Honduras', 'alpha-2': 'HN', 'country-code': '340' },
    { name: 'Hong Kong', 'alpha-2': 'HK', 'country-code': '344' },
    { name: 'Hungary', 'alpha-2': 'HU', 'country-code': '348' },
    { name: 'Iceland', 'alpha-2': 'IS', 'country-code': '352' },
    { name: 'India', 'alpha-2': 'IN', 'country-code': '356' },
    { name: 'Indonesia', 'alpha-2': 'ID', 'country-code': '360' },
    { name: 'Iran, Islamic Republic of', 'alpha-2': 'IR', 'country-code': '364' },
    { name: 'Iraq', 'alpha-2': 'IQ', 'country-code': '368' },
    { name: 'Ireland', 'alpha-2': 'IE', 'country-code': '372' },
    { name: 'Isle of Man', 'alpha-2': 'IM', 'country-code': '833' },
    { name: 'Israel', 'alpha-2': 'IL', 'country-code': '376' },
    { name: 'Italy', 'alpha-2': 'IT', 'country-code': '380' },
    { name: 'Jamaica', 'alpha-2': 'JM', 'country-code': '388' },
    { name: 'Japan', 'alpha-2': 'JP', 'country-code': '392' },
    { name: 'Jersey', 'alpha-2': 'JE', 'country-code': '832' },
    { name: 'Jordan', 'alpha-2': 'JO', 'country-code': '400' },
    { name: 'Kazakhstan', 'alpha-2': 'KZ', 'country-code': '398' },
    { name: 'Kenya', 'alpha-2': 'KE', 'country-code': '404' },
    { name: 'Kiribati', 'alpha-2': 'KI', 'country-code': '296' },
    { name: "Korea, Democratic People's Republic of", 'alpha-2': 'KP', 'country-code': '408' },
    { name: 'Korea, Republic of', 'alpha-2': 'KR', 'country-code': '410' },
    { name: 'Kuwait', 'alpha-2': 'KW', 'country-code': '414' },
    { name: 'Kyrgyzstan', 'alpha-2': 'KG', 'country-code': '417' },
    { name: "Lao People's Democratic Republic", 'alpha-2': 'LA', 'country-code': '418' },
    { name: 'Latvia', 'alpha-2': 'LV', 'country-code': '428' },
    { name: 'Lebanon', 'alpha-2': 'LB', 'country-code': '422' },
    { name: 'Lesotho', 'alpha-2': 'LS', 'country-code': '426' },
    { name: 'Liberia', 'alpha-2': 'LR', 'country-code': '430' },
    { name: 'Libya', 'alpha-2': 'LY', 'country-code': '434' },
    { name: 'Liechtenstein', 'alpha-2': 'LI', 'country-code': '438' },
    { name: 'Lithuania', 'alpha-2': 'LT', 'country-code': '440' },
    { name: 'Luxembourg', 'alpha-2': 'LU', 'country-code': '442' },
    { name: 'Macao', 'alpha-2': 'MO', 'country-code': '446' },
    { name: 'Macedonia, the former Yugoslav Republic of', 'alpha-2': 'MK', 'country-code': '807' },
    { name: 'Madagascar', 'alpha-2': 'MG', 'country-code': '450' },
    { name: 'Malawi', 'alpha-2': 'MW', 'country-code': '454' },
    { name: 'Malaysia', 'alpha-2': 'MY', 'country-code': '458' },
    { name: 'Maldives', 'alpha-2': 'MV', 'country-code': '462' },
    { name: 'Mali', 'alpha-2': 'ML', 'country-code': '466' },
    { name: 'Malta', 'alpha-2': 'MT', 'country-code': '470' },
    { name: 'Marshall Islands', 'alpha-2': 'MH', 'country-code': '584' },
    { name: 'Martinique', 'alpha-2': 'MQ', 'country-code': '474' },
    { name: 'Mauritania', 'alpha-2': 'MR', 'country-code': '478' },
    { name: 'Mauritius', 'alpha-2': 'MU', 'country-code': '480' },
    { name: 'Mayotte', 'alpha-2': 'YT', 'country-code': '175' },
    { name: 'Mexico', 'alpha-2': 'MX', 'country-code': '484' },
    { name: 'Micronesia, Federated States of', 'alpha-2': 'FM', 'country-code': '583' },
    { name: 'Moldova, Republic of', 'alpha-2': 'MD', 'country-code': '498' },
    { name: 'Monaco', 'alpha-2': 'MC', 'country-code': '492' },
    { name: 'Mongolia', 'alpha-2': 'MN', 'country-code': '496' },
    { name: 'Montenegro', 'alpha-2': 'ME', 'country-code': '499' },
    { name: 'Montserrat', 'alpha-2': 'MS', 'country-code': '500' },
    { name: 'Morocco', 'alpha-2': 'MA', 'country-code': '504' },
    { name: 'Mozambique', 'alpha-2': 'MZ', 'country-code': '508' },
    { name: 'Myanmar', 'alpha-2': 'MM', 'country-code': '104' },
    { name: 'Namibia', 'alpha-2': 'NA', 'country-code': '516' },
    { name: 'Nauru', 'alpha-2': 'NR', 'country-code': '520' },
    { name: 'Nepal', 'alpha-2': 'NP', 'country-code': '524' },
    { name: 'Netherlands', 'alpha-2': 'NL', 'country-code': '528' },
    { name: 'New Caledonia', 'alpha-2': 'NC', 'country-code': '540' },
    { name: 'New Zealand', 'alpha-2': 'NZ', 'country-code': '554' },
    { name: 'Nicaragua', 'alpha-2': 'NI', 'country-code': '558' },
    { name: 'Niger', 'alpha-2': 'NE', 'country-code': '562' },
    { name: 'Nigeria', 'alpha-2': 'NG', 'country-code': '566' },
    { name: 'Niue', 'alpha-2': 'NU', 'country-code': '570' },
    { name: 'Norfolk Island', 'alpha-2': 'NF', 'country-code': '574' },
    { name: 'Northern Mariana Islands', 'alpha-2': 'MP', 'country-code': '580' },
    { name: 'Norway', 'alpha-2': 'NO', 'country-code': '578' },
    { name: 'Oman', 'alpha-2': 'OM', 'country-code': '512' },
    { name: 'Pakistan', 'alpha-2': 'PK', 'country-code': '586' },
    { name: 'Palau', 'alpha-2': 'PW', 'country-code': '585' },
    { name: 'Palestine, State of', 'alpha-2': 'PS', 'country-code': '275' },
    { name: 'Panama', 'alpha-2': 'PA', 'country-code': '591' },
    { name: 'Papua New Guinea', 'alpha-2': 'PG', 'country-code': '598' },
    { name: 'Paraguay', 'alpha-2': 'PY', 'country-code': '600' },
    { name: 'Peru', 'alpha-2': 'PE', 'country-code': '604' },
    { name: 'Philippines', 'alpha-2': 'PH', 'country-code': '608' },
    { name: 'Pitcairn', 'alpha-2': 'PN', 'country-code': '612' },
    { name: 'Poland', 'alpha-2': 'PL', 'country-code': '616' },
    { name: 'Portugal', 'alpha-2': 'PT', 'country-code': '620' },
    { name: 'Puerto Rico', 'alpha-2': 'PR', 'country-code': '630' },
    { name: 'Qatar', 'alpha-2': 'QA', 'country-code': '634' },
    { name: 'Réunion', 'alpha-2': 'RE', 'country-code': '638' },
    { name: 'Romania', 'alpha-2': 'RO', 'country-code': '642' },
    { name: 'Russian Federation', 'alpha-2': 'RU', 'country-code': '643' },
    { name: 'Rwanda', 'alpha-2': 'RW', 'country-code': '646' },
    { name: 'Saint Barthélemy', 'alpha-2': 'BL', 'country-code': '652' },
    { name: 'Saint Helena, Ascension and Tristan da Cunha', 'alpha-2': 'SH', 'country-code': '654' },
    { name: 'Saint Kitts and Nevis', 'alpha-2': 'KN', 'country-code': '659' },
    { name: 'Saint Lucia', 'alpha-2': 'LC', 'country-code': '662' },
    { name: 'Saint Martin (French part)', 'alpha-2': 'MF', 'country-code': '663' },
    { name: 'Saint Pierre and Miquelon', 'alpha-2': 'PM', 'country-code': '666' },
    { name: 'Saint Vincent and the Grenadines', 'alpha-2': 'VC', 'country-code': '670' },
    { name: 'Samoa', 'alpha-2': 'WS', 'country-code': '882' },
    { name: 'San Marino', 'alpha-2': 'SM', 'country-code': '674' },
    { name: 'Sao Tome and Principe', 'alpha-2': 'ST', 'country-code': '678' },
    { name: 'Saudi Arabia', 'alpha-2': 'SA', 'country-code': '682' },
    { name: 'Senegal', 'alpha-2': 'SN', 'country-code': '686' },
    { name: 'Serbia', 'alpha-2': 'RS', 'country-code': '688' },
    { name: 'Seychelles', 'alpha-2': 'SC', 'country-code': '690' },
    { name: 'Sierra Leone', 'alpha-2': 'SL', 'country-code': '694' },
    { name: 'Singapore', 'alpha-2': 'SG', 'country-code': '702' },
    { name: 'Sint Maarten (Dutch part)', 'alpha-2': 'SX', 'country-code': '534' },
    { name: 'Slovakia', 'alpha-2': 'SK', 'country-code': '703' },
    { name: 'Slovenia', 'alpha-2': 'SI', 'country-code': '705' },
    { name: 'Solomon Islands', 'alpha-2': 'SB', 'country-code': '090' },
    { name: 'Somalia', 'alpha-2': 'SO', 'country-code': '706' },
    { name: 'South Africa', 'alpha-2': 'ZA', 'country-code': '710' },
    { name: 'South Georgia and the South Sandwich Islands', 'alpha-2': 'GS', 'country-code': '239' },
    { name: 'South Sudan', 'alpha-2': 'SS', 'country-code': '728' },
    { name: 'Spain', 'alpha-2': 'ES', 'country-code': '724' },
    { name: 'Sri Lanka', 'alpha-2': 'LK', 'country-code': '144' },
    { name: 'Sudan', 'alpha-2': 'SD', 'country-code': '729' },
    { name: 'Suriname', 'alpha-2': 'SR', 'country-code': '740' },
    { name: 'Svalbard and Jan Mayen', 'alpha-2': 'SJ', 'country-code': '744' },
    { name: 'Swaziland', 'alpha-2': 'SZ', 'country-code': '748' },
    { name: 'Sweden', 'alpha-2': 'SE', 'country-code': '752' },
    { name: 'Switzerland', 'alpha-2': 'CH', 'country-code': '756' },
    { name: 'Syrian Arab Republic', 'alpha-2': 'SY', 'country-code': '760' },
    { name: 'Taiwan, Province of China', 'alpha-2': 'TW', 'country-code': '158' },
    { name: 'Tajikistan', 'alpha-2': 'TJ', 'country-code': '762' },
    { name: 'Tanzania, United Republic of', 'alpha-2': 'TZ', 'country-code': '834' },
    { name: 'Thailand', 'alpha-2': 'TH', 'country-code': '764' },
    { name: 'Timor-Leste', 'alpha-2': 'TL', 'country-code': '626' },
    { name: 'Togo', 'alpha-2': 'TG', 'country-code': '768' },
    { name: 'Tokelau', 'alpha-2': 'TK', 'country-code': '772' },
    { name: 'Tonga', 'alpha-2': 'TO', 'country-code': '776' },
    { name: 'Trinidad and Tobago', 'alpha-2': 'TT', 'country-code': '780' },
    { name: 'Tunisia', 'alpha-2': 'TN', 'country-code': '788' },
    { name: 'Turkey', 'alpha-2': 'TR', 'country-code': '792' },
    { name: 'Turkmenistan', 'alpha-2': 'TM', 'country-code': '795' },
    { name: 'Turks and Caicos Islands', 'alpha-2': 'TC', 'country-code': '796' },
    { name: 'Tuvalu', 'alpha-2': 'TV', 'country-code': '798' },
    { name: 'Uganda', 'alpha-2': 'UG', 'country-code': '800' },
    { name: 'Ukraine', 'alpha-2': 'UA', 'country-code': '804' },
    { name: 'United Arab Emirates', 'alpha-2': 'AE', 'country-code': '784' },
    { name: 'United Kingdom', 'alpha-2': 'GB', 'country-code': '826' },
    { name: 'United States', 'alpha-2': 'US', 'country-code': '840' },
    { name: 'United States Minor Outlying Islands', 'alpha-2': 'UM', 'country-code': '581' },
    { name: 'Uruguay', 'alpha-2': 'UY', 'country-code': '858' },
    { name: 'Uzbekistan', 'alpha-2': 'UZ', 'country-code': '860' },
    { name: 'Vanuatu', 'alpha-2': 'VU', 'country-code': '548' },
    { name: 'Venezuela, Bolivarian Republic of', 'alpha-2': 'VE', 'country-code': '862' },
    { name: 'Viet Nam', 'alpha-2': 'VN', 'country-code': '704' },
    { name: 'Virgin Islands, British', 'alpha-2': 'VG', 'country-code': '092' },
    { name: 'Virgin Islands, U.S.', 'alpha-2': 'VI', 'country-code': '850' },
    { name: 'Wallis and Futuna', 'alpha-2': 'WF', 'country-code': '876' },
    { name: 'Western Sahara', 'alpha-2': 'EH', 'country-code': '732' },
    { name: 'Yemen', 'alpha-2': 'YE', 'country-code': '887' },
    { name: 'Zambia', 'alpha-2': 'ZM', 'country-code': '894' },
    { name: 'Zimbabwe', 'alpha-2': 'ZW', 'country-code': '716' },
];

publicConstants.AllowedSegmentUSStates = [
    { name: 'Alabama', code: 'AL' },
    { name: 'Alaska', code: 'AK' },
    { name: 'Arizona', code: 'AZ' },
    { name: 'Arkansas', code: 'AR' },
    { name: 'California', code: 'CA' },
    { name: 'Colorado', code: 'CO' },
    { name: 'Connecticut', code: 'CT' },
    { name: 'Delaware', code: 'DE' },
    { name: 'Florida', code: 'FL' },
    { name: 'Georgia', code: 'GA' },
    { name: 'Hawaii', code: 'HI' },
    { name: 'Idaho', code: 'ID' },
    { name: 'Illinois', code: 'IL' },
    { name: 'Indiana', code: 'IN' },
    { name: 'Iowa', code: 'IA' },
    { name: 'Kansas', code: 'KS' },
    { name: 'Kentucky', code: 'KY' },
    { name: 'Louisiana', code: 'LA' },
    { name: 'Maine', code: 'ME' },
    { name: 'Maryland', code: 'MD' },
    { name: 'Massachusetts', code: 'MA' },
    { name: 'Michigan', code: 'MI' },
    { name: 'Minnesota', code: 'MN' },
    { name: 'Mississippi', code: 'MS' },
    { name: 'Missouri', code: 'MO' },
    { name: 'Montana', code: 'MT' },
    { name: 'Nebraska', code: 'NE' },
    { name: 'Nevada', code: 'NV' },
    { name: 'New Hampshire', code: 'NH' },
    { name: 'New Jersey', code: 'NJ' },
    { name: 'New Mexico', code: 'NM' },
    { name: 'New York', code: 'NY' },
    { name: 'North Carolina', code: 'NC' },
    { name: 'North Dakota', code: 'ND' },
    { name: 'Ohio', code: 'OH' },
    { name: 'Oklahoma', code: 'OK' },
    { name: 'Oregon', code: 'OR' },
    { name: 'Pennsylvania', code: 'PA' },
    { name: 'Rhode Island', code: 'RI' },
    { name: 'South Carolina', code: 'SC' },
    { name: 'South Dakota', code: 'SD' },
    { name: 'Tennessee', code: 'TN' },
    { name: 'Texas', code: 'TX' },
    { name: 'Utah', code: 'UT' },
    { name: 'Vermont', code: 'VT' },
    { name: 'Virginia', code: 'VA' },
    { name: 'Washington', code: 'WA' },
    { name: 'West Virginia', code: 'WV' },
    { name: 'Wisconsin', code: 'WI' },
    { name: 'Wyoming', code: 'WY' },
];

publicConstants.AllowedSegmentLocationDistances = ['25', '50', '75', '100', '150', '200'];

/**
 * Map external advertisers from internal identifier to display name
 * @type {*[]}
 */
publicConstants.ExternalPlatform = [
    // Mediamath is permanently disabled so start.io is 2
    { id: 2, displayName: 'Start.io' },
];

publicConstants.retargetingAudiences = {};
publicConstants.retargetingAudiences.status = {
    PENDING: { value: 'pending', label: 'Pending' },
    QUERYING: { value: 'querying', label: 'Querying' },
    TRANSMITTING: { value: 'transmitting', label: 'Transmitting' },
    COMPLETED: { value: 'completed', label: 'Completed' },
    PARTIALLY_COMPLETED: { value: 'partially completed', label: 'Partially Completed' },
    ERROR: { value: 'error', label: 'Error' },
};
publicConstants.retargetingAudiences.audienceType = {
    APPSELECTOR: { label: 'AppSelector', value: 'APPSELECTOR' },
    TMT: { label: 'TMT', value: 'TMT' },
};

publicConstants.AudienceTransmission = {
    /* 841 = Customer Success, 893 = Vistar, 1506 = T-Mobile In-house, 1662 = Magenta Audience Network Segments, 1564 = T-Mobile O&O */
    WhiteListedOrgIdsForAutoTransmission: [841, 893, 1506, 1662, 1564],
};

// Statically analyzable named exports. Rollup's commonjs plugin extracts
// each property of this object literal as a named export, enabling ES module
// consumers to `import { X } from '@pushspring/ps-common/lib/constants-public'`.
// Values reference the same objects publicConstants holds, so the runtime
// shape is identical to `module.exports = publicConstants`.
module.exports = {
    Age: publicConstants.Age,
    AllowedCountries: publicConstants.AllowedCountries,
    AllowedExplorerSegmentAttributes: publicConstants.AllowedExplorerSegmentAttributes,
    AllowedSegmentAttributes: publicConstants.AllowedSegmentAttributes,
    AllowedSegmentCountries: publicConstants.AllowedSegmentCountries,
    AllowedSegmentLanguages: publicConstants.AllowedSegmentLanguages,
    AllowedSegmentLocationDistances: publicConstants.AllowedSegmentLocationDistances,
    AllowedSegmentModifiers: publicConstants.AllowedSegmentModifiers,
    AllowedSegmentUSStates: publicConstants.AllowedSegmentUSStates,
    ApprovalStatus: publicConstants.ApprovalStatus,
    AudienceTransmission: publicConstants.AudienceTransmission,
    BetaLevels: publicConstants.BetaLevels,
    BuiltInSegments: publicConstants.BuiltInSegments,
    BuiltInSegmentsMaxId: publicConstants.BuiltInSegmentsMaxId,
    CustomAudienceType: publicConstants.CustomAudienceType,
    DataPartnerReportCategories: publicConstants.DataPartnerReportCategories,
    DataPartnerStatus: publicConstants.DataPartnerStatus,
    DataPartners: publicConstants.DataPartners,
    DataScienceTeam: publicConstants.DataScienceTeam,
    DisplayAge: publicConstants.DisplayAge,
    DisplayGender: publicConstants.DisplayGender,
    DisplayIncome: publicConstants.DisplayIncome,
    DisplayPlatform: publicConstants.DisplayPlatform,
    DisplayTimeOfDay: publicConstants.DisplayTimeOfDay,
    ExternalIntegrations: publicConstants.ExternalIntegrations,
    ExternalIntegrationsTemplate: publicConstants.ExternalIntegrationsTemplate,
    ExternalPlatform: publicConstants.ExternalPlatform,
    FilePickerAPIKey: publicConstants.FilePickerAPIKey,
    FilePickerBucket: publicConstants.FilePickerBucket,
    Gender: publicConstants.Gender,
    Income: publicConstants.Income,
    IntegrationCategories: publicConstants.IntegrationCategories,
    LightweightPartnerList: publicConstants.LightweightPartnerList,
    LightweightPartners: publicConstants.LightweightPartners,
    Marketplace: publicConstants.Marketplace,
    MobileApps: publicConstants.MobileApps,
    OrgRoles: publicConstants.OrgRoles,
    OrgToSegmentContributingPartnerMapping: publicConstants.OrgToSegmentContributingPartnerMapping,
    OrgType: publicConstants.OrgType,
    PSGameGenres: publicConstants.PSGameGenres,
    PaginationHeaders: publicConstants.PaginationHeaders,
    PSGenres: publicConstants.PSGenres,
    PartnerAttributeTypes: publicConstants.PartnerAttributeTypes,
    PartnerImport: publicConstants.PartnerImport,
    PartnerIngestion: publicConstants.PartnerIngestion,
    PartnerList: publicConstants.PartnerList,
    PartnerRollups: publicConstants.PartnerRollups,
    PartnerTransmitSegmentLogs: publicConstants.PartnerTransmitSegmentLogs,
    PartnerTransmitSegmentSchedules: publicConstants.PartnerTransmitSegmentSchedules,
    Partners: publicConstants.Partners,
    PersonaSegments: publicConstants.PersonaSegments,
    Personas: publicConstants.Personas,
    Platform: publicConstants.Platform,
    PlatformSegments: publicConstants.PlatformSegments,
    PushSpringDisplayIncome: publicConstants.PushSpringDisplayIncome,
    PushSpringIncome: publicConstants.PushSpringIncome,
    PushSpringIncomeMedian: publicConstants.PushSpringIncomeMedian,
    QueryBuilderAttributes: publicConstants.QueryBuilderAttributes,
    RollupSegments: publicConstants.RollupSegments,
    SLAOneDay: publicConstants.SLAOneDay,
    SLAThreeToFiveDays: publicConstants.SLAThreeToFiveDays,
    SLATwoToThreeDays: publicConstants.SLATwoToThreeDays,
    SearchMetadata: publicConstants.SearchMetadata,
    SegmentContributingPartners: publicConstants.SegmentContributingPartners,
    SegmentModifierLookup: publicConstants.SegmentModifierLookup,
    SegmentModifierSubtype: publicConstants.SegmentModifierSubtype,
    SegmentModifierSubtypeName: publicConstants.SegmentModifierSubtypeName,
    SegmentReports: publicConstants.SegmentReports,
    StaffRoles: publicConstants.StaffRoles,
    Store: publicConstants.Store,
    TAdsAge: publicConstants.TAdsAge,
    TAdsGender: publicConstants.TAdsGender,
    TargetListExport: publicConstants.TargetListExport,
    TaxonomyHierarchy: publicConstants.TaxonomyHierarchy,
    UploadAudience: publicConstants.UploadAudience,
    UserOrgRoleList: publicConstants.UserOrgRoleList,
    UserOrgRoles: publicConstants.UserOrgRoles,
    WarehouseSegments: publicConstants.WarehouseSegments,
    explorerAttributes: publicConstants.explorerAttributes,
    featureFlags: publicConstants.featureFlags,
    maximumLookalikeSizeByCountry: publicConstants.maximumLookalikeSizeByCountry,
    retargetingAudiences: publicConstants.retargetingAudiences,
    standardSLA: publicConstants.standardSLA,
};
